import { APIWarningTypeResponseType } from "../../services/APIEarlyWarningService";
import { CustomWarningIcon, EarlWarningFLW, EarlWarningHRW, EarlWarningLIG, GUSWarningIcon, IconEarthquake, IconEWAirStrike, IconEWNuclear, IconHighWind, IconMarineWeather, IconTsunami, LandSlideLSW } from "../iconSet/IconSet";
import { AdministrativeLevels, EarlyWarningTypeTypes } from "./CreateWarningTypes";

export const earlyWarningTypes: EarlyWarningTypeTypes[] = [
    {
        wType: "HRW", 
        wDescription: "Heavy Rain Early Warning", 
        wName: "Heavy Rain Early Warning", 
        wCode:"LSW1",
        sDescription: "Prevailing showery condition in the Island is likely to continue  over the island. above 12.0 mm are likely at some places in Ambalangoda Division.",
        icon: <EarlWarningHRW width="5rem" color="var(--color-text)"/>,
        
    },
    {
        wType: "LSW", 
        wDescription: "Landslide Early Warning", 
        wName: "Landslide Early Warning",
        wCode:"LSW10", 
        sDescription: "Since the rainfall within the past 24 hours has exceeded 150mm, if the rain continues, evacuate to a safe location to avoid the risk of landslides, slope failures, rock falls, cutting failures and ground subsidence.",
        icon: <LandSlideLSW width="6rem" color="var(--color-text)"/>,
    },
    {
        wType: "FLW",
        wDescription: "Flood Early Warning",
        wName: "Flood Early Warning",
        wCode:"LSW12", 
        sDescription: "A flood early warning has been issued for the Attanagalu Oya Basin, and residents in those areas, as well as vehicle drivers passing through those areas, are requested to pay close attention in this regard.",
        icon: <EarlWarningFLW width="5rem" color="var(--color-text)"/>,
    },
    {
        wType: "LIG",
        wDescription: "Severe Lightning Early Waring",
        wName: "Severe Lightning Early Waring",
        wCode:"LSW13", 
        sDescription: "Thundershowers accompanied by severe lightning are likely to occur at several places in Northern Province. There may be temporary localized strong winds during thundershowers. General public is kindly requested to take adequate precautions to minimize damages caused by lightning activity.",
        icon: <EarlWarningLIG width="5rem" color="var(--color-text)"/>,
    },
    {
        wType: "HWN",
        wDescription: "High Wind Warning",
        wName: "High Wind Warning",
        wCode:"LSW3", 
        sDescription: "",
        icon: <IconHighWind width="5rem" color="var(--color-text)"/>,
    },
    {
        wType: "MWA",
        wDescription: "Marine Weather Warnings",
        wName: "Marine Weather Warnings",
        wCode:"LSW2", 
        sDescription: "",
        icon: <IconMarineWeather width="5rem" color="var(--color-text)"/>,
    },
    {
        wType: "NTW",
        wDescription: "Nuclear Threat Warnings",
        wName: "Nuclear Threat Warnings",
        wCode:"LSW1", 
        sDescription: "",
        icon: <IconEWNuclear width="5rem" color="var(--color-text)"/>,
    },
    {
        wType: "ASW",
        wDescription: "Air Strike Warnings",
        wName: "Air Strike Warnings",
        wCode:"LSW0", 
        sDescription: "",
        icon: <IconEWAirStrike width="5rem" color="var(--color-text)"/>,
    },
    {
        wType: "TW",
        wDescription: "Tsunami Warnings",
        wName: "Tsunami Warnings",
        wCode:"LSW2", 
        sDescription: "",
        icon: <IconTsunami width="5rem" color="var(--color-text)"/>,
    },
    {
        wType: "CUS",
        wDescription: "Custom Warnings",
        wName: "Custom Warnings",
        wCode:"CUS", 
        sDescription: "",
        icon: <CustomWarningIcon width="5rem" color="var(--color-text)"/>,
    },
    {
        wType: "GUS",
        wDescription: "Gust Warning",
        wName: "Gust Warning",
        wCode:"GUS", 
        sDescription: "",
        icon: <GUSWarningIcon width="5rem" color="var(--color-text)"/>,
    },
    {
        wType: "EQW",
        wDescription: "Earthquake",
        wName: "Earthquake",
        wCode:"EQW", 
        sDescription: "",
        icon: <IconEarthquake width="5rem" color="var(--color-text)"/>,
    },
]

export const earlyWarningTypes2: APIWarningTypeResponseType[] = [
    {
        hazardType: "HRW", 
        warningName: "Heavy Rain Early Warning",
        warningId: "LSW1",
        warningType: "WR",
        departments: "EWD"
    },
    {
        hazardType: "LSW", 
        warningName: "Landslide Early Warning",
        warningId:"LSW10", 
        warningType: "WR",
        departments: "EWD"
    },
    {
        hazardType: "FLW",
        warningName: "Flood Early Warning",
        warningId:"LSW12", 
        warningType: "WR",
        departments: "EWD"
    },
    {
        hazardType: "LIG",
        warningName: "Severe Lightning Early Waring",
        warningId:"LSW13", 
        warningType: "WR",
        departments: "EWD"
    },
    {
        hazardType: "HWN",
        warningName: "High Wind Warning",
        warningId:"LSW3", 
        warningType: "WR",
        departments: "EWD"
    },
    {
        hazardType: "MWA",
        warningName: "Marine Weather Warnings",
        warningId:"LSW2", 
        warningType: "WR",
        departments: "EWD"
    },
    {
        hazardType: "NTW",
        warningName: "Nuclear Threat Warnings",
        warningId:"LSW1", 
        warningType: "WR",
        departments: "EWD"
    },
    {
        hazardType: "ASW",
        warningName: "Air Strike Warnings",
        warningId:"LSW0", 
        warningType: "WR",
        departments: "EWD"
    },
]

// Location data
export const sriLankaAdministrationLevel: AdministrativeLevels = {
    LK1: {
        name: "Western",
        adminLevel: "province",
        children: {
            LK11: {
                name: "Colombo",
                adminLevel: "district",
                children: {
                    LK1103: { name: "Colombo", adminLevel: "DS" },
                    LK1106: { name: "Kolonnawa", adminLevel: "DS" },
                    LK1109: { name: "Kaduwela", adminLevel: "DS" },
                    LK1112: { name: "Homagama", adminLevel: "DS" },
                    LK1115: { name: "Seethawaka", adminLevel: "DS" },
                    LK1118: { name: "Padukka", adminLevel: "DS" },
                    LK1121: { name: "Maharagama", adminLevel: "DS" },
                    LK1124: { name: "Sri Jayawardanapura Kotte", adminLevel: "DS" },
                    LK1127: { name: "Thimbirigasyaya", adminLevel: "DS" },
                    LK1130: { name: "Dehiwala", adminLevel: "DS" },
                    LK1131: { name: "Ratmalana", adminLevel: "DS" },
                    LK1133: { name: "Moratuwa", adminLevel: "DS" },
                    LK1136: { name: "Kesbewa", adminLevel: "DS" }
                }
            },
            LK12: {
                name: "Gampaha",
                adminLevel: "district",
                children: {
                    LK1227: { name: "Attanagalla", adminLevel: "DS" },
                    LK1209: { name: "Divulapitiya", adminLevel: "DS" },
                    LK1239: { name: "Biyagama", adminLevel: "DS" },
                    LK1230: { name: "Dompe", adminLevel: "DS" },
                    LK1224: { name: "Gampaha", adminLevel: "DS" },
                    LK1221: { name: "Ja Ela", adminLevel: "DS" },
                    LK1236: { name: "Kelaniya", adminLevel: "DS" },
                    LK1215: { name: "Minuwangoda", adminLevel: "DS" },
                    LK1212: { name: "Mirigama", adminLevel: "DS" },
                    LK1233: { name: "Mahara", adminLevel: "DS" },
                    LK1206: { name: "Katana", adminLevel: "DS" },
                    LK1203: { name: "Negombo", adminLevel: "DS" },
                    LK1218: { name: "Wattala", adminLevel: "DS" }
                }
            },
            LK13: {
                name: "Kalutara",
                adminLevel: "district",
                children: {
                    LK1333: { name: "Agalawatta", adminLevel: "DS" },
                    LK1306: { name: "Bandaragama", adminLevel: "DS" },
                    LK1324: { name: "Beruwala", adminLevel: "DS" },
                    LK1327: { name: "Dodangoda", adminLevel: "DS" },
                    LK1310: { name: "Ingiriya", adminLevel: "DS" },
                    LK1309: { name: "Horana", adminLevel: "DS" },
                    LK1312: { name: "Bulathsinhala", adminLevel: "DS" },
                    LK1321: { name: "Kalutara", adminLevel: "DS" },
                    LK1315: { name: "Madurawala", adminLevel: "DS" },
                    LK1330: { name: "Matugama", adminLevel: "DS" },
                    LK1303: { name: "Panadura", adminLevel: "DS" },
                    LK1336: { name: "Palindanuwara", adminLevel: "DS" },
                    LK1339: { name: "Walallawita", adminLevel: "DS" },
                    LK1318: { name: "Millaniya", adminLevel: "DS" }
                }
            }
        }
    }, 
    LK2: {
        name: "Central",
        adminLevel: "province",
        children: {
            LK21: {
                name: "Kandy",
                adminLevel: "district",
                children: {
                    LK2109: { name: "Akurana", adminLevel: "DS" },
                    LK2148: { name: "Deltota", adminLevel: "DS" },
                    LK2130: { name: "Gangawata Korale", adminLevel: "DS" },
                    LK2133: { name: "Harispattuwa", adminLevel: "DS" },
                    LK2134: { name: "Hatharaliyadda", adminLevel: "DS" },
                    LK2127: { name: "Kundasale", adminLevel: "DS" },
                    LK2106: { name: "Poojapitiya", adminLevel: "DS" },
                    LK2103: { name: "Tumpane", adminLevel: "DS" },
                    LK2154: { name: "Ganga Ihala Korale", adminLevel: "DS" },
                    LK2157: { name: "Pasbagekorale", adminLevel: "DS" },
                    LK2115: { name: "Panvila", adminLevel: "DS" },
                    LK2112: { name: "Pathadumbara", adminLevel: "DS" },
                    LK2145: { name: "Pathahewaheta", adminLevel: "DS" },
                    LK2136: { name: "Yatinuwara", adminLevel: "DS" },
                    LK2139: { name: "Udunuwara", adminLevel: "DS" },
                    LK2118: { name: "Ududumbara", adminLevel: "DS" },
                    LK2151: { name: "Udapalatha", adminLevel: "DS" }
                }
            },
            LK22: {
                name: "Matale",
                adminLevel: "district",
                children: {
                    LK2221: { name: "Ambanganga", adminLevel: "DS" },
                    LK2206: { name: "Dambulla", adminLevel: "DS" },
                    LK2203: { name: "Galewela", adminLevel: "DS" },
                    LK2218: { name: "Matale", adminLevel: "DS" },
                    LK2224: { name: "Laggala", adminLevel: "DS" },
                    LK2209: { name: "Naula", adminLevel: "DS" },
                    LK2212: { name: "Pallepola", adminLevel: "DS" },
                    LK2230: { name: "Rattota", adminLevel: "DS" },
                    LK2215: { name: "Yatawatta", adminLevel: "DS" },
                    LK2227: { name: "Wilgamuwa", adminLevel: "DS" },
                    LK2233: { name: "Ukuwela", adminLevel: "DS" }
                }
            },
            LK23: {
                name: "Nuwara Eliya",
                adminLevel: "district",
                children: {
                    LK2315: { name: "Ambagamuwa", adminLevel: "DS" },
                    LK2306: { name: "Hanguranketa", adminLevel: "DS" },
                    LK2303: { name: "Kothmale", adminLevel: "DS" },
                    LK2312: { name: "Nuwara Eliya", adminLevel: "DS" },
                    LK2309: { name: "Walapane", adminLevel: "DS" }
                }
            }
        }
    },
    LK3: {
        name: "Southern",
        adminLevel: "province",
        children: {
            LK31: {
                name: "Galle",
                adminLevel: "district",
                children: {
                    LK3145: { name: "Akmeemana", adminLevel: "DS" },
                    LK3127: { name: "Baddegama", adminLevel: "DS" },
                    LK3106: { name: "Balapitiya", adminLevel: "DS" },
                    LK3103: { name: "Bentota", adminLevel: "DS" },
                    LK3139: { name: "Galle4Gravets", adminLevel: "DS" },
                    LK3134: { name: "Gonapinuwala", adminLevel: "DS" },
                    LK3133: { name: "Ambalangoda", adminLevel: "DS" },
                    LK3136: { name: "Hikkaduwa", adminLevel: "DS" },
                    LK3112: { name: "Elpitiya", adminLevel: "DS" },
                    LK3109: { name: "Karandeniya", adminLevel: "DS" },
                    LK3124: { name: "Nagoda", adminLevel: "DS" },
                    LK3121: { name: "Neluwa", adminLevel: "DS" },
                    LK3115: { name: "Niyagama", adminLevel: "DS" },
                    LK3130: { name: "Welivitiya-Divitura", adminLevel: "DS" },
                    LK3154: { name: "Habaraduwa", adminLevel: "DS" },
                    LK3118: { name: "Thawalama", adminLevel: "DS" },
                    LK3142: { name: "Bope-Poddala", adminLevel: "DS" },
                    LK3148: { name: "Yakkalamulla", adminLevel: "DS" }
                }
            },
            LK32: {
                name: "Matara",
                adminLevel: "district",
                children: {
                    LK3218: { name: "Akuressa", adminLevel: "DS" },
                    LK3215: { name: "Athuraliya", adminLevel: "DS" },
                    LK3245: { name: "Devinuwara", adminLevel: "DS" },
                    LK3248: { name: "Dikwella", adminLevel: "DS" },
                    LK3230: { name: "Hakmana", adminLevel: "DS" },
                    LK3227: { name: "Kaburupitiya", adminLevel: "DS" },
                    LK3242: { name: "Matara Four Gravets", adminLevel: "DS" },
                    LK3212: { name: "Mulatiyana", adminLevel: "DS" },
                    LK3224: { name: "Malimbada", adminLevel: "DS" },
                    LK3221: { name: "Welipitiya", adminLevel: "DS" },
                    LK3233: { name: "Kirinda Puhulwella", adminLevel: "DS" },
                    LK3206: { name: "Kotapola", adminLevel: "DS" },
                    LK3209: { name: "Pasgoda", adminLevel: "DS" },
                    LK3203: { name: "Pitabaddara", adminLevel: "DS" },
                    LK3236: { name: "Thihagoda", adminLevel: "DS" },
                    LK3239: { name: "Weligama", adminLevel: "DS" }
                }
            },
            LK33: {
                name: "Hambantota",
                adminLevel: "district",
                children: {
                    LK3315: { name: "Ambalantota", adminLevel: "DS" },
                    LK3318: { name: "Angunakolapelessa", adminLevel: "DS" },
                    LK3330: { name: "Beliatta", adminLevel: "DS" },
                    LK3312: { name: "Hambantota", adminLevel: "DS" },
                    LK3324: { name: "Katuwana", adminLevel: "DS" },
                    LK3327: { name: "Okewela", adminLevel: "DS" },
                    LK3306: { name: "Lunugamwehera", adminLevel: "DS" },
                    LK3303: { name: "Sooriyawewa", adminLevel: "DS" },
                    LK3309: { name: "Thissamaharama", adminLevel: "DS" },
                    LK3333: { name: "Tangalle", adminLevel: "DS" },
                    LK3321: { name: "Weeraketiya", adminLevel: "DS" },
                    LK3325: { name: "Walasmulla", adminLevel: "DS" }
                }
            }
        }
    },
    LK4: {
        name: "Northern",
        adminLevel: "province",
        children: {
            LK41: {
                // Jaffna District (LK41)
                name: "Jaffna",
                adminLevel: "district",
                children: {
                    LK4136: { name: "Jaffna", adminLevel: "DS" },
                    LK4133: { name: "Nallur", adminLevel: "DS" },
                    LK4103: { name: "Islands North (Kayts)", adminLevel: "DS" },
                    LK4139: { name: "Islands South (Velanai)", adminLevel: "DS" },
                    LK4104: { name: "Karainagar", adminLevel: "DS" },
                    LK4124: { name: "Vadamaradchchi East", adminLevel: "DS" },
                    LK4121: { name: "Vadamaradchchi South-West (Karaveddy)", adminLevel: "DS" },
                    LK4127: { name: "Vadamaradchi North (Point Pedro)", adminLevel: "DS" },
                    LK4118: { name: "Valikamam East (Kopay)", adminLevel: "DS" },
                    LK4112: { name: "Valikamam North (Thllippalai)", adminLevel: "DS" },
                    LK4115: { name: "Valikamam South (Uduvil)", adminLevel: "DS" },
                    LK4109: { name: "Valikamam South West (Sandilipay)", adminLevel: "DS" },
                    LK4106: { name: "Valikamam West (Chankanai)", adminLevel: "DS" },
                    LK4130: { name: "Thenmaradchi (Chavakachcheri)", adminLevel: "DS" }
                }
            },
            LK42: {
                // Mannar District (LK42)
                name: "Mannar",
                adminLevel: "district",
                children: {
                    LK4203: { name: "Mannar Town", adminLevel: "DS" },
                    LK4206: { name: "Manthai West", adminLevel: "DS" },
                    LK4209: { name: "Madhu", adminLevel: "DS" },
                    LK4212: { name: "Nanaddan", adminLevel: "DS" },
                    LK4215: { name: "Musali", adminLevel: "DS" }
                }
            },
            LK43: {
                // Vavuniya District (LK43)
                name: "Vavuniya",
                adminLevel: "district",
                children: {
                    LK4309: { name: "Vavuniya", adminLevel: "DS" },
                    LK4303: { name: "Vavuniya North", adminLevel: "DS" },
                    LK4306: { name: "Vavuniya South", adminLevel: "DS" },
                    LK4312: { name: "Vengalacheddikulam", adminLevel: "DS" }
                }
            },
            LK44: {
                // Mullaitivu District (LK44)
                name: "Mullaitivu",
                adminLevel: "district",
                children: {
                    LK4406: { name: "Manthai East", adminLevel: "DS" },
                    LK4415: { name: "Maritimepattu", adminLevel: "DS" },
                    LK4412: { name: "Oddusuddan", adminLevel: "DS" },
                    LK4403: { name: "Thunukkai", adminLevel: "DS" },
                    LK4418: { name: "Welioya", adminLevel: "DS" }
                }
            },
            LK45: {
                // Kilinochchi District (LK45)
                name: "Kilinochchi",
                adminLevel: "district",
                children: {
                    LK4506: { name: "Kandavalai", adminLevel: "DS" },
                    LK4509: { name: "Karachchi", adminLevel: "DS" },
                    LK4512: { name: "Poonakary", adminLevel: "DS" },
                    LK4503: { name: "Pachchilaipalli", adminLevel: "DS" }
                }
            }
        }
    },
    LK5: {
        name: "Eastern",
        adminLevel: "province",
        children: {
            LK51: {
                // Batticaloa District (LK51)
                name: "Batticaloa",
                adminLevel: "district",
                children: {
                    LK5112: { name: "Eravur Pattu", adminLevel: "DS" },
                    LK5115: { name: "Eravur Town", adminLevel: "DS" },
                    LK5124: { name: "Kattankudy", adminLevel: "DS" },
                    LK5118: { name: "Manmunai North", adminLevel: "DS" },
                    LK5127: { name: "Manmunai Pattu", adminLevel: "DS" },
                    LK5136: { name: "Manmunai South & Eruvil Pattu", adminLevel: "DS" },
                    LK5130: { name: "Manmunai South West", adminLevel: "DS" },
                    LK5121: { name: "Manmunai West", adminLevel: "DS" },
                    LK5133: { name: "Porativu Pattu", adminLevel: "DS" }
                }
            },
            LK52: {
                // Ampara District (LK52)
                name: "Ampara",
                adminLevel: "district",
                children: {
                    LK5215: { name: "Ampara", adminLevel: "DS" },
                    LK5233: { name: "Addalaichenai", adminLevel: "DS" },
                    LK5236: { name: "Akkaraipattu", adminLevel: "DS" },
                    LK5239: { name: "Alayadivembu", adminLevel: "DS" },
                    LK5203: { name: "Dehiattakandiya", adminLevel: "DS" },
                    LK5234: { name: "Irakkamam", adminLevel: "DS" },
                    LK5216: { name: "Navithanveli", adminLevel: "DS" },
                    LK5245: { name: "Tirukkovil", adminLevel: "DS" },
                    LK5218: { name: "Sammanthurai", adminLevel: "DS" },
                    LK5221: { name: "Kalmunai", adminLevel: "DS" },
                    LK5225: { name: "Sainthamaruthu", adminLevel: "DS" },
                    LK5227: { name: "Karaitivu", adminLevel: "DS" },
                    LK5230: { name: "Nintavur", adminLevel: "DS" },
                    LK5242: { name: "Damana", adminLevel: "DS" },
                    LK5206: { name: "Padiyathalawa", adminLevel: "DS" },
                    LK5209: { name: "Mahaoya", adminLevel: "DS" },
                    LK5212: { name: "Uhana", adminLevel: "DS" },
                    LK5248: { name: "Pottuvil", adminLevel: "DS" },
                    LK5251: { name: "Lahugala", adminLevel: "DS" }
                }
            },
            LK53: {
                // Trincomalee District (LK53)
                name: "Trincomalee",
                adminLevel: "district",
                children: {
                    LK5309: { name: "Gomarankadawala", adminLevel: "DS" },
                    LK5312: { name: "Morawewa", adminLevel: "DS" },
                    LK5321: { name: "Kantale", adminLevel: "DS" },
                    LK5324: { name: "Kinniya", adminLevel: "DS" },
                    LK5327: { name: "Muthur", adminLevel: "DS" },
                    LK5306: { name: "Kuchchaweli", adminLevel: "DS" },
                    LK5303: { name: "Padavi Sri Pura", adminLevel: "DS" },
                    LK5315: { name: "Town & Gravets", adminLevel: "DS" },
                    LK5318: { name: "Thambalagamuwa", adminLevel: "DS" },
                    LK5330: { name: "Seruvila", adminLevel: "DS" },
                    LK5333: { name: "Verugal", adminLevel: "DS" }
                }
            }
        }
    },
    LK6: {
        name: "North Western",
        adminLevel: "province",
        children: {
            LK61: {
                // Kurunegala District (LK61)
                name: "Kurunegala",
                adminLevel: "district",
                children: {
                    LK6184: { name: "Alawwa", adminLevel: "DS" },
                    LK6149: { name: "Bamunakotuwa", adminLevel: "DS" },
                    LK6112: { name: "Ambanpola", adminLevel: "DS" },
                    LK6109: { name: "Ehetuwewa", adminLevel: "DS" },
                    LK6106: { name: "Galgamuwa", adminLevel: "DS" },
                    LK6103: { name: "Giribawa", adminLevel: "DS" },
                    LK6133: { name: "Ganewatta", adminLevel: "DS" },
                    LK6130: { name: "Ibbagamuwa", adminLevel: "DS" },
                    LK6115: { name: "Kotawehera", adminLevel: "DS" },
                    LK6154: { name: "Kurunegala", adminLevel: "DS" },
                    LK6142: { name: "Bingiriya", adminLevel: "DS" },
                    LK6139: { name: "Kobeigane", adminLevel: "DS" },
                    LK6151: { name: "Maspotha", adminLevel: "DS" },
                    LK6160: { name: "Mawathagama", adminLevel: "DS" },
                    LK6124: { name: "Maho", adminLevel: "DS" },
                    LK6157: { name: "Mallawapitiya", adminLevel: "DS" },
                    LK6178: { name: "Pannala", adminLevel: "DS" },
                    LK6127: { name: "Polpitigama", adminLevel: "DS" },
                    LK6118: { name: "Rasnayakapura", adminLevel: "DS" },
                    LK6163: { name: "Rideegama", adminLevel: "DS" },
                    LK6166: { name: "Weerabugedara", adminLevel: "DS" },
                    LK6136: { name: "Wariyapola", adminLevel: "DS" },
                    LK6175: { name: "Udubaddawa", adminLevel: "DS" },
                    LK6169: { name: "Kuliyapitiya East", adminLevel: "DS" },
                    LK6172: { name: "Kuliyapitiya West", adminLevel: "DS" },
                    LK6148: { name: "Panduwasnuwara East", adminLevel: "DS" },
                    LK6145: { name: "Panduwasnuwara West", adminLevel: "DS" },
                    LK6181: { name: "Narammala", adminLevel: "DS" },
                    LK6187: { name: "Polgahawela", adminLevel: "DS" }
                }
            },
            LK62: {
                // Puttalam District (LK62)
                name: "Puttalam",
                adminLevel: "district",
                children: {
                    LK6224: { name: "Anamaduwa", adminLevel: "DS" },
                    LK6230: { name: "Arachchikattuwa", adminLevel: "DS" },
                    LK6203: { name: "Kalpitiya", adminLevel: "DS" },
                    LK6209: { name: "Karuwalagaswewa", adminLevel: "DS" },
                    LK6233: { name: "Chilaw", adminLevel: "DS" },
                    LK6236: { name: "Madampe", adminLevel: "DS" },
                    LK6218: { name: "Mundel", adminLevel: "DS" },
                    LK6221: { name: "Mahakumbukkadawala", adminLevel: "DS" },
                    LK6239: { name: "Mahawewa", adminLevel: "DS" },
                    LK6215: { name: "Puttalam", adminLevel: "DS" },
                    LK6227: { name: "Pallama", adminLevel: "DS" },
                    LK6248: { name: "Dankotuwa", adminLevel: "DS" },
                    LK6242: { name: "Nattandiya", adminLevel: "DS" },
                    LK6245: { name: "Wennappuwa", adminLevel: "DS" },
                    LK6206: { name: "Vanathavilluwa", adminLevel: "DS" },
                    LK6212: { name: "Nawagattegama", adminLevel: "DS" }
                }
            }
        }
    },
    LK7: {
        name: "North Central",
        adminLevel: "province",
        children: {
            LK71: {
                // Anuradhapura District (LK71)
                name: "Anuradhapura",
                adminLevel: "district",
                children: {
                    LK7127: { name: "Galenbidunuwewa", adminLevel: "DS" },
                    LK7121: { name: "Kahatagasdigiliya", adminLevel: "DS" },
                    LK7106: { name: "Kebithigollewa", adminLevel: "DS" },
                    LK7109: { name: "Medawachchiya", adminLevel: "DS" },
                    LK7112: { name: "Mahawilachchiya", adminLevel: "DS" },
                    LK7124: { name: "Horowpathana", adminLevel: "DS" },
                    LK7115: { name: "Nuwaragam Palatha Central", adminLevel: "DS" },
                    LK7133: { name: "Nuwaragam Palatha East", adminLevel: "DS" },
                    LK7136: { name: "Nachchaduwa", adminLevel: "DS" },
                    LK7130: { name: "Mihinthale", adminLevel: "DS" },
                    LK7139: { name: "Nochchiyagama", adminLevel: "DS" },
                    LK7142: { name: "Rajanganaya", adminLevel: "DS" },
                    LK7118: { name: "Rambewa", adminLevel: "DS" },
                    LK7145: { name: "Thambuththegama", adminLevel: "DS" },
                    LK7151: { name: "Thirappane", adminLevel: "DS" },
                    LK7148: { name: "Thalawa", adminLevel: "DS" },
                    LK7160: { name: "Ipalogama", adminLevel: "DS" },
                    LK7163: { name: "Galnewa", adminLevel: "DS" },
                    LK7166: { name: "Palagala", adminLevel: "DS" },
                    LK7154: { name: "Kekirawa", adminLevel: "DS" },
                    LK7157: { name: "Palugaswewa", adminLevel: "DS" }
                }
            },
            LK72: {
                // Polonnaruwa District (LK72)
                name: "Polonnaruwa",
                adminLevel: "district",
                children: {
                    LK7212: { name: "Dimbulagala", adminLevel: "DS" },
                    LK7218: { name: "Elahera", adminLevel: "DS" },
                    LK7203: { name: "Higurakgoda", adminLevel: "DS" },
                    LK7206: { name: "Medirigiriya", adminLevel: "DS" },
                    LK7209: { name: "Lankapura", adminLevel: "DS" },
                    LK7215: { name: "Thamankaduwa", adminLevel: "DS" },
                    LK7210: { name: "Welikanda", adminLevel: "DS" }
                }
            }
        }
    },
    LK8: {
        name: "Uva",
        adminLevel: "province",
        children: {
            LK81: {
                // Badulla District (LK81)
                name: "Badulla",
                adminLevel: "district",
                children: {
                    LK8121: { name: "Badulla", adminLevel: "DS" },
                    LK8133: { name: "Bandarawela", adminLevel: "DS" },
                    LK8136: { name: "Ella", adminLevel: "DS" },
                    LK8142: { name: "Haldummulla", adminLevel: "DS" },
                    LK8124: { name: "Hali-Ela", adminLevel: "DS" },
                    LK8139: { name: "Haputale", adminLevel: "DS" },
                    LK8112: { name: "Kandeketiya", adminLevel: "DS" },
                    LK8118: { name: "Passara", adminLevel: "DS" },
                    LK8103: { name: "Mahiyanganaya", adminLevel: "DS" },
                    LK8109: { name: "Meegahakiula", adminLevel: "DS" },
                    LK8115: { name: "Soranathota", adminLevel: "DS" },
                    LK8127: { name: "Uvaparanagama", adminLevel: "DS" },
                    LK8130: { name: "Welimada", adminLevel: "DS" },
                    LK8218: { name: "Badalkumbura", adminLevel: "DS" },
                    LK8203: { name: "Bibile", adminLevel: "DS" },
                    LK8224: { name: "Buttala", adminLevel: "DS" },
                    LK8206: { name: "Madulla", adminLevel: "DS" },
                    LK8215: { name: "Monaragala", adminLevel: "DS" },
                    LK8233: { name: "Sevanagala", adminLevel: "DS" },
                    LK8212: { name: "Siyambalanduwa", adminLevel: "DS" },
                    LK8230: { name: "Thanamalwila", adminLevel: "DS" },
                    LK8227: { name: "Katharagama", adminLevel: "DS" },
                    LK8221: { name: "Wellawaya", adminLevel: "DS" }
                }
            },
            LK82: {
                // Monaragala District (LK82)
                name: "Monaragala",
                adminLevel: "district",
                children: {
                    LK8218: { name: "Badalkumbura", adminLevel: "DS" },
                    LK8203: { name: "Bibile", adminLevel: "DS" },
                    LK8224: { name: "Buttala", adminLevel: "DS" },
                    LK8206: { name: "Madulla", adminLevel: "DS" },
                    LK8215: { name: "Monaragala", adminLevel: "DS" },
                    LK8233: { name: "Sevanagala", adminLevel: "DS" },
                    LK8212: { name: "Siyambalanduwa", adminLevel: "DS" },
                    LK8230: { name: "Thanamalwila", adminLevel: "DS" },
                    LK8227: { name: "Katharagama", adminLevel: "DS" },
                    LK8221: { name: "Wellawaya", adminLevel: "DS" }
                }
            }
        }
    },
    LK9: {
        name: "Sabaragamuwa",
        adminLevel: "province",
        children: {
            LK91: {
                // Ratnapura District (LK91)
                name: "Ratnapura",
                adminLevel: "district",
                children: {
                    LK9130: { name: "Ayagama", adminLevel: "DS" },
                    LK9118: { name: "Balangoda", adminLevel: "DS" },
                    LK9103: { name: "Eheliyagoda", adminLevel: "DS" },
                    LK9142: { name: "Godakawela", adminLevel: "DS" },
                    LK9115: { name: "Imbulpe", adminLevel: "DS" },
                    LK9139: { name: "Kahawattha", adminLevel: "DS" },
                    LK9133: { name: "Kalawana", adminLevel: "DS" },
                    LK9109: { name: "Kiriella", adminLevel: "DS" },
                    LK9136: { name: "Nivithigala", adminLevel: "DS" },
                    LK9124: { name: "Pelmadulla", adminLevel: "DS" },
                    LK9112: { name: "Ratnapura", adminLevel: "DS" },
                    LK9145: { name: "Weligepola", adminLevel: "DS" },
                    LK9127: { name: "Elapatha", adminLevel: "DS" },
                    LK9148: { name: "Embilipitiya", adminLevel: "DS" },
                    LK9151: { name: "Kolonna", adminLevel: "DS" }
                }
            },
            LK92: {
                // Kegalle District (LK92)
                name: "Kegalle",
                adminLevel: "district",
                children: {
                    LK9209: { name: "Aranayake", adminLevel: "DS" },
                    LK9224: { name: "Bulathkohipitiya", adminLevel: "DS" },
                    LK9230: { name: "Dehiowita", adminLevel: "DS" },
                    LK9233: { name: "Deraniyagala", adminLevel: "DS" },
                    LK9215: { name: "Galigamuwa", adminLevel: "DS" },
                    LK9212: { name: "Kegalle", adminLevel: "DS" },
                    LK9206: { name: "Mawanella", adminLevel: "DS" },
                    LK9227: { name: "Yatiyantota", adminLevel: "DS" },
                    LK9218: { name: "Warakapola", adminLevel: "DS" },
                    LK9221: { name: "Ruwanwella", adminLevel: "DS" },
                    LK9121: { name: "Opanayake", adminLevel: "DS" }
                }
            }
        }
    }
}

export const sriLankaSeaAdministrationLevel: AdministrativeLevels = {
    SAR1: {
        name: "Puttalam to Mannar",
        adminLevel: "sea",
    },
    SAR2: {
        name: "Mannar to Kankasanturai",
        adminLevel: "sea",
    },
    SAR3: {
        name: "Kankasanturai to Trincomalee",
        adminLevel: "sea",
    },
    SAR4: {
        name: "Batticaloe to trincomalee",
        adminLevel: "sea",
    },
    SAR5: {
        name: "Batticaloa to Pottuvil",
        adminLevel: "sea",
    },
    SAR6: {
        name: "Pottuvil to Hambantota",
        adminLevel: "sea",
    },
    SAR7: {
        name: "Hambantota to Galle",
        adminLevel: "sea",
    },
    SAR8: {
        name: "Galle to Colombo",
        adminLevel: "sea",
    },
    SAR9: {
        name: "Colombo to Puttalam",
        adminLevel: "sea",
    },
}

// export const maldivesAdministrativeLevel: AdministrativeLevels = {
//     // Haa Alifu Atoll (MV001)
//     MV001: {
//         name: "Haa Alifu",
//         adminLevel: "atoll",
//         children: {
//             MV001001: { name: "Thuraakunu", adminLevel: "island" },
//             MV001002: { name: "Uligamu", adminLevel: "island" },
//             MV001003: { name: "Berinmadhoo", adminLevel: "island" },
//             MV001005: { name: "Mulhadhoo", adminLevel: "island" },
//             MV001006: { name: "Huvarafushi", adminLevel: "island" },
//             MV001007: { name: "Ihavandhoo", adminLevel: "island" },
//             MV001008: { name: "Kelaa", adminLevel: "island" },
//             MV001009: { name: "Vashafaru", adminLevel: "island" },
//             MV001010: { name: "Dhihdhoo", adminLevel: "island" },
//             MV001011: { name: "Filladhoo", adminLevel: "island" },
//             MV001012: { name: "Maarandhoo", adminLevel: "island" },
//             MV001013: { name: "Thakandhoo", adminLevel: "island" },
//             MV001014: { name: "Utheemu", adminLevel: "island" },
//             MV001015: { name: "Muraidhoo", adminLevel: "island" },
//             MV001016: { name: "Baarah", adminLevel: "island" },
//             MV001018: { name: "Alidhoo", adminLevel: "island" },
//             MV001019: { name: "Alidhuffarufinolhu", adminLevel: "island" },
//             MV001024: { name: "Gaamathikulhudhoo", adminLevel: "island" },
//             MV001032: { name: "Maafinolhu", adminLevel: "island" },
//             MV001035: { name: "Manafaru", adminLevel: "island" },
//             MV001037: { name: "Medhafushi", adminLevel: "island" },
//             MV001039: { name: "Naridhoo", adminLevel: "island" },
//             MV001042: { name: "Van'gaaru", adminLevel: "island" }
//         }
//     },
//     // Haa Dhaalu Atoll (MV002)
//     MV002: {
//         name: "Haa Dhaalu",
//         adminLevel: "atoll",
//         children: {
//             MV002003: { name: "Hanimaadhoo", adminLevel: "island" },
//             MV002004: { name: "Finey", adminLevel: "island" },
//             MV002005: { name: "Naivaadhoo", adminLevel: "island" },
//             MV002006: { name: "Hirimaradhoo", adminLevel: "island" },
//             MV002007: { name: "Nolhivaranfaru", adminLevel: "island" },
//             MV002008: { name: "Nellaidhoo", adminLevel: "island" },
//             MV002009: { name: "Nolhivaramu", adminLevel: "island" },
//             MV002010: { name: "Kurin'bee", adminLevel: "island" },
//             MV002012: { name: "Kulhudhuffushi", adminLevel: "island" },
//             MV002013: { name: "Kumundhoo", adminLevel: "island" },
//             MV002014: { name: "Neykurendhoo", adminLevel: "island" },
//             MV002015: { name: "Vaikaradhoo", adminLevel: "island" },
//             MV002017: { name: "Makunudhoo", adminLevel: "island" },
//             MV002018: { name: "Dhipparufushi", adminLevel: "island" },
//             MV002021: { name: "Hon'daafushi", adminLevel: "island" },
//             MV002026: { name: "Kudafarufasgandu", adminLevel: "island" },
//             MV002027: { name: "Kudamuraidhoo", adminLevel: "island" },
//             MV002031: { name: "Muiri", adminLevel: "island" },
//             MV002032: { name: "Naagoashi", adminLevel: "island" },
//             MV002034: { name: "Theefaridhoo", adminLevel: "island" }
//         }
//     },
//     // Shaviyani Atoll (MV003)
//     MV003: {
//         name: "Shaviyani",
//         adminLevel: "atoll",
//         children: {
//             MV003001: { name: "Kan'ditheemu", adminLevel: "island" },
//             MV003002: { name: "Noomaraa", adminLevel: "island" },
//             MV003003: { name: "Goidhoo", adminLevel: "island" },
//             MV003004: { name: "Feydhoo", adminLevel: "island" },
//             MV003005: { name: "Feevah", adminLevel: "island" },
//             MV003006: { name: "Bileiyfahi", adminLevel: "island" },
//             MV003007: { name: "Foakaidhoo", adminLevel: "island" },
//             MV003008: { name: "Narudhoo", adminLevel: "island" },
//             MV003010: { name: "Maroshi", adminLevel: "island" },
//             MV003011: { name: "Lhaimagu", adminLevel: "island" },
//             MV003012: { name: "Firun'baidhoo", adminLevel: "island" },
//             MV003013: { name: "Komandoo", adminLevel: "island" },
//             MV003014: { name: "Maaun'goodhoo", adminLevel: "island" },
//             MV003015: { name: "Funadhoo", adminLevel: "island" },
//             MV003016: { name: "Milandhoo", adminLevel: "island" },
//             MV003022: { name: "Dholhiyadhoo", adminLevel: "island" },
//             MV003025: { name: "Ekasdhoo", adminLevel: "island" },
//             MV003026: { name: "Eriadhoo", adminLevel: "island" },
//             MV003028: { name: "Fushifaru", adminLevel: "island" },
//             MV003029: { name: "Gaakoshibi", adminLevel: "island" },
//             MV003032: { name: "Hurasfaru", adminLevel: "island" },
//             MV003033: { name: "Kakaaeriyadhoo", adminLevel: "island" },
//             MV003034: { name: "Kan'baalifaru", adminLevel: "island" },
//             MV003035: { name: "Keekimini", adminLevel: "island" },
//             MV003038: { name: "Kudalhaimendhoo", adminLevel: "island" },
//             MV003047: { name: "Madidhoo", adminLevel: "island" },
//             MV003048: { name: "Madikuredhdhoo", adminLevel: "island" },
//             MV003050: { name: "Medhukun'burudhoo", adminLevel: "island" },
//             MV003053: { name: "Naainfarufinolhu", adminLevel: "island" },
//             MV003059: { name: "Van'garu", adminLevel: "island" }
//         }
//     },
//     // Noonu Atoll (MV004)
//     MV004: {
//         name: "Noonu",
//         adminLevel: "atoll",
//         children: {
//             MV004001: { name: "Hen'badhoo", adminLevel: "island" },
//             MV004002: { name: "Ken'dhikulhudhoo", adminLevel: "island" },
//             MV004003: { name: "Maalhendhoo", adminLevel: "island" },
//             MV004004: { name: "Kudafari", adminLevel: "island" },
//             MV004005: { name: "Landhoo", adminLevel: "island" },
//             MV004006: { name: "Maafaru", adminLevel: "island" },
//             MV004007: { name: "Lhohi", adminLevel: "island" },
//             MV004008: { name: "Miladhoo", adminLevel: "island" },
//             MV004009: { name: "Magoodhoo", adminLevel: "island" },
//             MV004010: { name: "Manadhoo", adminLevel: "island" },
//             MV004011: { name: "Holhudhoo", adminLevel: "island" },
//             MV004012: { name: "Fohdhoo", adminLevel: "island" },
//             MV004013: { name: "Velidhoo", adminLevel: "island" },
//             MV004014: { name: "Ban'daidhihdhoo", adminLevel: "island" },
//             MV004017: { name: "Bomasdhoo", adminLevel: "island" },
//             MV004022: { name: "Dhigurah", adminLevel: "island" },
//             MV004024: { name: "Ehdhuffarumairah", adminLevel: "island" },
//             MV004025: { name: "Ekulhivaru", adminLevel: "island" },
//             MV004027: { name: "Felivaru", adminLevel: "island" },
//             MV004029: { name: "Fushivelavaru", adminLevel: "island" },
//             MV004031: { name: "Huivani", adminLevel: "island" },
//             MV004033: { name: "Huvan'dhumaavattaru", adminLevel: "island" },
//             MV004042: { name: "Kudafunafaru", adminLevel: "island" },
//             MV004043: { name: "Kudafushi", adminLevel: "island" },
//             MV004044: { name: "Kunnamalei", adminLevel: "island" },
//             MV004061: { name: "Loafaru", adminLevel: "island" },
//             MV004064: { name: "Maakurehdhoo", adminLevel: "island" },
//             MV004066: { name: "Maavelavaru", adminLevel: "island" },
//             MV004067: { name: "Medhafushi", adminLevel: "island" },
//             MV004068: { name: "Medhufaru", adminLevel: "island" },
//             MV004069: { name: "Minaavaru", adminLevel: "island" },
//             MV004071: { name: "Orivaru", adminLevel: "island" },
//             MV004073: { name: "Raafushi", adminLevel: "island" },
//             MV004074: { name: "Raalhulaakolhu", adminLevel: "island" },
//             MV004075: { name: "Randheli", adminLevel: "island" },
//             MV004076: { name: "Than'burudhoo", adminLevel: "island" },
//             MV004077: { name: "Than'burudhuffushi", adminLevel: "island" },
//             MV004079: { name: "Thoshigan'dukolhu", adminLevel: "island" },
//             MV004080: { name: "Vavathi", adminLevel: "island" }
//         }
//     },
//     // Lhaviyani Atoll (MV005)
//     MV005: {
//         name: "Lhaviyani",
//         adminLevel: "atoll",
//         children: {
//             MV005001: { name: "Hinnavaru", adminLevel: "island" },
//             MV005002: { name: "Naifaru", adminLevel: "island" },
//             MV005003: { name: "Kurendhoo", adminLevel: "island" },
//             MV005004: { name: "Olhuvelifushi", adminLevel: "island" },
//             MV005006: { name: "Aligau", adminLevel: "island" },
//             MV005009: { name: "Bodufinolhu", adminLevel: "island" },
//             MV005012: { name: "Dheruffinolhu", adminLevel: "island" },
//             MV005016: { name: "Faadhoo", adminLevel: "island" },
//             MV005020: { name: "Felivaru", adminLevel: "island" },
//             MV005025: { name: "Hudhufushi", adminLevel: "island" },
//             MV005026: { name: "Huravalhi", adminLevel: "island" },
//             MV005027: { name: "Innahuraa", adminLevel: "island" },
//             MV005029: { name: "Kanifushi", adminLevel: "island" },
//             MV005030: { name: "Kanuhuraa", adminLevel: "island" },
//             MV005031: { name: "Komandoo", adminLevel: "island" },
//             MV005032: { name: "Kudadhoo", adminLevel: "island" },
//             MV005033: { name: "Kurehdhoo", adminLevel: "island" },
//             MV005061: { name: "Lhohi", adminLevel: "island" },
//             MV005063: { name: "Maabinhuraa", adminLevel: "island" },
//             MV005065: { name: "Madhiriguraidhoo", adminLevel: "island" },
//             MV005070: { name: "Medha Adihuraa", adminLevel: "island" },
//             MV005074: { name: "Ookolhufinolhu", adminLevel: "island" },
//             MV005076: { name: "Thilamaafushi", adminLevel: "island" },
//             MV005080: { name: "Veyvah", adminLevel: "island" }
//         }
//     },
//     // Raa Atoll (MV006)
//     MV006: {
//         name: "Raa",
//         adminLevel: "atoll",
//         children: {
//             MV006001: { name: "Alifushi", adminLevel: "island" },
//             MV006002: { name: "Vaadhoo", adminLevel: "island" },
//             MV006003: { name: "Rasgetheemu", adminLevel: "island" },
//             MV006004: { name: "An'golhitheemu", adminLevel: "island" },
//             MV006005: { name: "Hulhudhuffaaru", adminLevel: "island" },
//             MV006006: { name: "Un'goofaaru", adminLevel: "island" },
//             MV006008: { name: "Maakurathu", adminLevel: "island" },
//             MV006009: { name: "Rasmaadhoo", adminLevel: "island" },
//             MV006010: { name: "Innamaadhoo", adminLevel: "island" },
//             MV006011: { name: "Maduvvari", adminLevel: "island" },
//             MV006012: { name: "In'guraidhoo", adminLevel: "island" },
//             MV006013: { name: "Fainu", adminLevel: "island" },
//             MV006014: { name: "Meedhoo", adminLevel: "island" },
//             MV006015: { name: "Kinolhas", adminLevel: "island" },
//             MV006017: { name: "Gaaun'doodhoo", adminLevel: "island" },
//             MV006018: { name: "Un'gulu", adminLevel: "island" },
//             MV006019: { name: "Dhuvaafaru", adminLevel: "island" },
//             MV006020: { name: "Aarah", adminLevel: "island" },
//             MV006024: { name: "Bodufarufinolhu", adminLevel: "island" },
//             MV006026: { name: "Bodufushi", adminLevel: "island" },
//             MV006027: { name: "Boduhaiykodi", adminLevel: "island" },
//             MV006028: { name: "Dheburidheythereyvaadhoo", adminLevel: "island" },
//             MV006030: { name: "Dhigali", adminLevel: "island" },
//             MV006035: { name: "Ehthigili", adminLevel: "island" },
//             MV006037: { name: "Faarufushi", adminLevel: "island" },
//             MV006039: { name: "Fasmendhoo", adminLevel: "island" },
//             MV006040: { name: "Fenfushi", adminLevel: "island" },
//             MV006041: { name: "Filaidhoo", adminLevel: "island" },
//             MV006042: { name: "Fuggiri", adminLevel: "island" },
//             MV006043: { name: "Furaveri", adminLevel: "island" },
//             MV006052: { name: "Huruvalhi", adminLevel: "island" },
//             MV006053: { name: "Ifuru", adminLevel: "island" },
//             MV006055: { name: "Kan'doogan'du", adminLevel: "island" },
//             MV006057: { name: "Kottefaru", adminLevel: "island" },
//             MV006059: { name: "Kudafushi", adminLevel: "island" },
//             MV006060: { name: "Kudakurathu", adminLevel: "island" },
//             MV006066: { name: "Kuroshigiri", adminLevel: "island" },
//             MV006093: { name: "Lhohi", adminLevel: "island" },
//             MV006094: { name: "Lin'boakandhoo", adminLevel: "island" },
//             MV006095: { name: "Lun'dhufushi", adminLevel: "island" },
//             MV006096: { name: "Maamin'gili", adminLevel: "island" },
//             MV006097: { name: "Maamunagau", adminLevel: "island" },
//             MV006099: { name: "Maanenfushi", adminLevel: "island" },
//             MV006103: { name: "Meedhupparu", adminLevel: "island" },
//             MV006106: { name: "Muravandhoo", adminLevel: "island" },
//             MV006111: { name: "Uthurumaafaru", adminLevel: "island" },
//             MV006116: { name: "Veyvah", adminLevel: "island" }
//         }
//     },
//     // Baa Atoll (MV007)
//     MV007: {
//         name: "Baa",
//         adminLevel: "atoll",
//         children: {
//             MV007001: { name: "Kudarikilu", adminLevel: "island" },
//             MV007002: { name: "Kamadhoo", adminLevel: "island" },
//             MV007003: { name: "Kendhoo", adminLevel: "island" },
//             MV007004: { name: "Kihaadhoo", adminLevel: "island" },
//             MV007005: { name: "Dhonfanu", adminLevel: "island" },
//             MV007006: { name: "Dharavandhoo", adminLevel: "island" },
//             MV007007: { name: "Maalhos", adminLevel: "island" },
//             MV007008: { name: "Eydhafushi", adminLevel: "island" },
//             MV007009: { name: "Thulhaadhoo", adminLevel: "island" },
//             MV007010: { name: "Hithaadhoo", adminLevel: "island" },
//             MV007011: { name: "Fulhadhoo", adminLevel: "island" },
//             MV007012: { name: "Fehendhoo", adminLevel: "island" },
//             MV007013: { name: "Goidhoo", adminLevel: "island" },
//             MV007015: { name: "Aidhoo", adminLevel: "island" },
//             MV007021: { name: "Bodufinolhu", adminLevel: "island" },
//             MV007022: { name: "Boifushi", adminLevel: "island" },
//             MV007024: { name: "Dhandhoo", adminLevel: "island" },
//             MV007026: { name: "Dhigudhefaru", adminLevel: "island" },
//             MV007027: { name: "Dhigufaruvinagan'du", adminLevel: "island" },
//             MV007029: { name: "Dhunikolhu", adminLevel: "island" },
//             MV007030: { name: "En'boodhoo", adminLevel: "island" },
//             MV007031: { name: "Fares", adminLevel: "island" },
//             MV007032: { name: "Finolhas", adminLevel: "island" },
//             MV007034: { name: "Fonimagoodhoo", adminLevel: "island" },
//             MV007035: { name: "Funadhoo", adminLevel: "island" },
//             MV007041: { name: "Hibalhidhoo", adminLevel: "island" },
//             MV007042: { name: "Hirundhoo", adminLevel: "island" },
//             MV007043: { name: "Horubadhoo", adminLevel: "island" },
//             MV007045: { name: "Huraafaru", adminLevel: "island" },
//             MV007046: { name: "Innafushi", adminLevel: "island" },
//             MV007048: { name: "Kanufushi", adminLevel: "island" },
//             MV007049: { name: "Kashidhoo", adminLevel: "island" },
//             MV007051: { name: "Kihaadhuffaru", adminLevel: "island" },
//             MV007052: { name: "Kihavahhuravalhi", adminLevel: "island" },
//             MV007054: { name: "Kunfunadhoo", adminLevel: "island" },
//             MV007055: { name: "Lan'daagiraavaru", adminLevel: "island" },
//             MV007097: { name: "Maamaduvvari", adminLevel: "island" },
//             MV007098: { name: "Maarikilu", adminLevel: "island" },
//             MV007102: { name: "Mendhoo", adminLevel: "island" },
//             MV007103: { name: "Milaidhoo", adminLevel: "island" },
//             MV007104: { name: "Miriandhoo", adminLevel: "island" },
//             MV007105: { name: "Mudhdhoo", adminLevel: "island" },
//             MV007106: { name: "Muthaafushi", adminLevel: "island" },
//             MV007110: { name: "Thiladhoo", adminLevel: "island" },
//             MV007111: { name: "Ufuligiri", adminLevel: "island" },
//             MV007112: { name: "Un'doodhoo", adminLevel: "island" },
//             MV007113: { name: "Vakkaru", adminLevel: "island" },
//             MV007118: { name: "Voavah", adminLevel: "island" }
//         }
//     },
//     // Alifu Alifu Atoll (MV008)
//     MV008: {
//         name: "Alifu Alifu",
//         adminLevel: "atoll",
//         children: {
//             MV008001: { name: "Thoddoo", adminLevel: "island" },
//             MV008002: { name: "Rasdhoo", adminLevel: "island" },
//             MV008003: { name: "Ukulhas", adminLevel: "island" },
//             MV008004: { name: "Mathiveri", adminLevel: "island" },
//             MV008005: { name: "Bodufolhudhoo", adminLevel: "island" },
//             MV008006: { name: "Feridhoo", adminLevel: "island" },
//             MV008007: { name: "Maalhos", adminLevel: "island" },
//             MV008008: { name: "Himendhoo", adminLevel: "island" },
//             MV008011: { name: "Bathalaa", adminLevel: "island" },
//             MV008013: { name: "Ellaidhoo", adminLevel: "island" },
//             MV008014: { name: "Etheremadivaru", adminLevel: "island" },
//             MV008015: { name: "Fesdhoo", adminLevel: "island" },
//             MV008019: { name: "Gaathafushi", adminLevel: "island" },
//             MV008020: { name: "Gangehi", adminLevel: "island" },
//             MV008021: { name: "Halaveli", adminLevel: "island" },
//             MV008022: { name: "Kan'dholhudhoo", adminLevel: "island" },
//             MV008023: { name: "Kudafolhudhoo", adminLevel: "island" },
//             MV008024: { name: "Kuramathi", adminLevel: "island" },
//             MV008037: { name: "Maagau", adminLevel: "island" },
//             MV008038: { name: "Maayafushi", adminLevel: "island" },
//             MV008041: { name: "Madoogali", adminLevel: "island" },
//             MV008042: { name: "Mathivereefinolhu", adminLevel: "island" },
//             MV008043: { name: "Mushimasmigili", adminLevel: "island" },
//             MV008044: { name: "Velidhoo", adminLevel: "island" },
//             MV008046: { name: "Veligan'du", adminLevel: "island" }
//         }
//     },
//     // Kaafu Atoll (MV009)
//     MV009: {
//         name: "Kaafu",
//         adminLevel: "atoll",
//         children: {
//             MV009001: { name: "Kaashidhoo", adminLevel: "island" },
//             MV009002: { name: "Gaafaru", adminLevel: "island" },
//             MV009003: { name: "Dhiffushi", adminLevel: "island" },
//             MV009004: { name: "Thulusdhoo", adminLevel: "island" },
//             MV009005: { name: "Huraa", adminLevel: "island" },
//             MV009006: { name: "Hinmafushi", adminLevel: "island" },
//             MV009007: { name: "Gulhi", adminLevel: "island" },
//             MV009008: { name: "Maafushi", adminLevel: "island" },
//             MV009009: { name: "Guraidhoo", adminLevel: "island" },
//             MV009010: { name: "Aanugan'dufinolhu", adminLevel: "island" },
//             MV009011: { name: "Aanugan'duhuraa", adminLevel: "island" },
//             MV009012: { name: "Aarah", adminLevel: "island" },
//             MV009013: { name: "Akasdhoo", adminLevel: "island" },
//             MV009014: { name: "Akirifushi", adminLevel: "island" },
//             MV009015: { name: "Asdhoo", adminLevel: "island" },
//             MV009016: { name: "Baros", adminLevel: "island" },
//             MV009017: { name: "Biyaadhoo", adminLevel: "island" },
//             MV009018: { name: "Boduban'dos", adminLevel: "island" },
//             MV009020: { name: "Bodufinolhu", adminLevel: "island" },
//             MV009021: { name: "Boduhithi", adminLevel: "island" },
//             MV009022: { name: "Boduhuraa", adminLevel: "island" },
//             MV009023: { name: "Bolifushi", adminLevel: "island" },
//             MV009025: { name: "Dhigufinolhu", adminLevel: "island" },
//             MV009026: { name: "Dhonfushi", adminLevel: "island" },
//             MV009027: { name: "Dhoonidhoo", adminLevel: "island" },
//             MV009028: { name: "Ehmafushi", adminLevel: "island" },
//             MV009029: { name: "En'boodhoo", adminLevel: "island" },
//             MV009030: { name: "En'boodhoofinolhu", adminLevel: "island" },
//             MV009031: { name: "Eriadhoo", adminLevel: "island" },
//             MV009032: { name: "Erruhhuraa", adminLevel: "island" },
//             MV009037: { name: "Farukolhufushi", adminLevel: "island" },
//             MV009038: { name: "Feydhoofinolhu", adminLevel: "island" },
//             MV009039: { name: "Fihaalhohi", adminLevel: "island" },
//             MV009041: { name: "Funfinolhu", adminLevel: "island" },
//             MV009042: { name: "Furanafushi", adminLevel: "island" },
//             MV009044: { name: "Gasfinolhu", adminLevel: "island" },
//             MV009045: { name: "Giraavaru", adminLevel: "island" },
//             MV009046: { name: "Girifushi", adminLevel: "island" },
//             MV009047: { name: "Gulhigaathuhuraa", adminLevel: "island" },
//             MV009048: { name: "Hastheem", adminLevel: "island" },
//             MV009049: { name: "Hathaafinolhu", adminLevel: "island" },
//             MV009050: { name: "Helen'geli", adminLevel: "island" },
//             MV009051: { name: "Hen'badhoo", adminLevel: "island" },
//             MV009052: { name: "Hulhule", adminLevel: "island" },
//             MV009053: { name: "Ihuru", adminLevel: "island" },
//             MV009055: { name: "Ithaafushi", adminLevel: "island" },
//             MV009056: { name: "Kagi", adminLevel: "island" },
//             MV009059: { name: "Kan'doomaafushi", adminLevel: "island" },
//             MV009060: { name: "Kan'duoiygiri", adminLevel: "island" },
//             MV009061: { name: "Kanifinolhu", adminLevel: "island" },
//             MV009062: { name: "Kanuoiyhuraa", adminLevel: "island" },
//             MV009064: { name: "Kohdhipparu", adminLevel: "island" },
//             MV009065: { name: "Kudaban'dos", adminLevel: "island" },
//             MV009066: { name: "Kudafinolhu", adminLevel: "island" },
//             MV009069: { name: "Kudahuraa", adminLevel: "island" },
//             MV009070: { name: "Lankanfinolhu", adminLevel: "island" },
//             MV009071: { name: "Lankanfushi", adminLevel: "island" },
//             MV009158: { name: "Lhohifushi", adminLevel: "island" },
//             MV009160: { name: "Maadhoo", adminLevel: "island" },
//             MV009161: { name: "Maaranfushi", adminLevel: "island" },
//             MV009162: { name: "Madivaru", adminLevel: "island" },
//             MV009163: { name: "Mahaanaelhihuraa", adminLevel: "island" },
//             MV009165: { name: "Makunudhoo", adminLevel: "island" },
//             MV009166: { name: "Makunufushi", adminLevel: "island" },
//             MV009168: { name: "Medhufinolhu", adminLevel: "island" },
//             MV009169: { name: "Meerufenfushi", adminLevel: "island" },
//             MV009170: { name: "Nakahchaahuraa", adminLevel: "island" },
//             MV009171: { name: "Nakaiychaafushi", adminLevel: "island" },
//             MV009172: { name: "Nashvilu", adminLevel: "island" },
//             MV009173: { name: "Noofinolhu", adminLevel: "island" },
//             MV009174: { name: "Olhigan'dufinolhu", adminLevel: "island" },
//             MV009175: { name: "Olhuhali", adminLevel: "island" },
//             MV009176: { name: "Olhuveli", adminLevel: "island" },
//             MV009177: { name: "Rannaalhi", adminLevel: "island" },
//             MV009181: { name: "Tholhimaraahuraa", adminLevel: "island" },
//             MV009182: { name: "Thulhaagiri", adminLevel: "island" },
//             MV009184: { name: "Thun'bafushi", adminLevel: "island" },
//             MV009185: { name: "Vaadhoo", adminLevel: "island" },
//             MV009186: { name: "Vaagali", adminLevel: "island" },
//             MV009187: { name: "Vabbinfaru", adminLevel: "island" },
//             MV009190: { name: "Velassaru", adminLevel: "island" },
//             MV009191: { name: "Veligan'duhuraa", adminLevel: "island" },
//             MV009192: { name: "Vihamanaafushi", adminLevel: "island" },
//             MV009193: { name: "Vilin'gilimathidhahuraa", adminLevel: "island" },
//             MV009194: { name: "Villivaru", adminLevel: "island" },
//             MV009195: { name: "Ziyaaraiyfushi", adminLevel: "island" }
//         }
//     },
//     // Vaavu Atoll (MV010)
//     MV010: {
//         name: "Vaavu",
//         adminLevel: "atoll",
//         children: {
//             MV010001: { name: "Fulidhoo", adminLevel: "island" },
//             MV010002: { name: "Thinadhoo", adminLevel: "island" },
//             MV010003: { name: "Felidhoo", adminLevel: "island" },
//             MV010004: { name: "Keyodhoo", adminLevel: "island" },
//             MV010005: { name: "Rakeedhoo", adminLevel: "island" },
//             MV010006: { name: "Aarah", adminLevel: "island" },
//             MV010007: { name: "Alimathaa", adminLevel: "island" },
//             MV010008: { name: "Anbaraa", adminLevel: "island" },
//             MV010009: { name: "Bodumohoraa", adminLevel: "island" },
//             MV010011: { name: "Fohtheyobodufushi", adminLevel: "island" },
//             MV010012: { name: "Hulhidhoo", adminLevel: "island" },
//             MV010015: { name: "Kunaaveshi", adminLevel: "island" }
//         }
//     },
//     // Faafu Atoll (MV011)
//     MV011: {
//         name: "Faafu",
//         adminLevel: "atoll",
//         children: {
//             MV011001: { name: "Feeali", adminLevel: "island" },
//             MV011002: { name: "Bileiydhoo", adminLevel: "island" },
//             MV011003: { name: "Magoodhoo", adminLevel: "island" },
//             MV011004: { name: "Dharan'boodhoo", adminLevel: "island" },
//             MV011005: { name: "Nilandhoo", adminLevel: "island" },
//             MV011008: { name: "En'bulufushi", adminLevel: "island" },
//             MV011010: { name: "Filitheyo", adminLevel: "island" },
//             MV011011: { name: "Himithi", adminLevel: "island" },
//             MV011012: { name: "Jinnathugau", adminLevel: "island" },
//             MV011028: { name: "Maafushi", adminLevel: "island" },
//             MV011032: { name: "Minimasgali", adminLevel: "island" }
//         }
//     },
//     // Dhaalu Atoll (MV012)
//     MV012: {
//         name: "Dhaalu",
//         adminLevel: "atoll",
//         children: {
//             MV012001: { name: "Meedhoo", adminLevel: "island" },
//             MV012002: { name: "Ban'didhoo", adminLevel: "island" },
//             MV012003: { name: "Rin'budhoo", adminLevel: "island" },
//             MV012004: { name: "Hulhudheli", adminLevel: "island" },
//             MV012007: { name: "Maaen'boodhoo", adminLevel: "island" },
//             MV012008: { name: "Kudahuvadhoo", adminLevel: "island" },
//             MV012009: { name: "Aluvifushi", adminLevel: "island" },
//             MV012011: { name: "Boarikifinolhu", adminLevel: "island" },
//             MV012015: { name: "Dhoores", adminLevel: "island" },
//             MV012016: { name: "En'boodhoofushi", adminLevel: "island" },
//             MV012017: { name: "Faandhoo", adminLevel: "island" },
//             MV012020: { name: "Hiriyafushi", adminLevel: "island" },
//             MV012024: { name: "Kan'dinmaa", adminLevel: "island" },
//             MV012026: { name: "Kedhigan'du", adminLevel: "island" },
//             MV012052: { name: "Lhohi", adminLevel: "island" },
//             MV012054: { name: "Maafushi", adminLevel: "island" },
//             MV012055: { name: "Maagau", adminLevel: "island" },
//             MV012057: { name: "Meedhuffushi", adminLevel: "island" },
//             MV012060: { name: "Olhuveli", adminLevel: "island" },
//             MV012065: { name: "Uhdhoo", adminLevel: "island" },
//             MV012068: { name: "Velavaru", adminLevel: "island" },
//             MV012069: { name: "Vommuli", adminLevel: "island" }
//         }
//     },
//     // Meemu Atoll (MV013)
//     MV013: {
//         name: "Meemu",
//         adminLevel: "atoll",
//         children: {
//             MV013001: { name: "Raiymandhoo", adminLevel: "island" },
//             MV013002: { name: "Madifushi", adminLevel: "island" },
//             MV013003: { name: "Veyvah", adminLevel: "island" },
//             MV013004: { name: "Mulah", adminLevel: "island" },
//             MV013005: { name: "Muli", adminLevel: "island" },
//             MV013006: { name: "Naalaafushi", adminLevel: "island" },
//             MV013007: { name: "Kolhufushi", adminLevel: "island" },
//             MV013008: { name: "Dhiggaru", adminLevel: "island" },
//             MV013009: { name: "Maduvvari", adminLevel: "island" },
//             MV013010: { name: "Boahuraa", adminLevel: "island" },
//             MV013012: { name: "Dhekunuboduveli", adminLevel: "island" },
//             MV013016: { name: "Fenfuraaveli", adminLevel: "island" },
//             MV013017: { name: "Gaakurali", adminLevel: "island" },
//             MV013018: { name: "Gasveli", adminLevel: "island" },
//             MV013020: { name: "Hakuraahuraa", adminLevel: "island" },
//             MV013022: { name: "Hurasveli", adminLevel: "island" },
//             MV013024: { name: "Kekuraalhuveli", adminLevel: "island" },
//             MV013025: { name: "Kudausfushi", adminLevel: "island" },
//             MV013058: { name: "Maausfushi", adminLevel: "island" },
//             MV013059: { name: "Medhufushi", adminLevel: "island" },
//             MV013061: { name: "Seedheehuraa", adminLevel: "island" },
//             MV013062: { name: "Seedheehuraaveligan'du", adminLevel: "island" },
//             MV013063: { name: "Thuvaru", adminLevel: "island" },
//             MV013065: { name: "Uthuruboduveli", adminLevel: "island" },
//             MV013066: { name: "Uthurugaseveli", adminLevel: "island" }
//         }
//     },
//     // Thaa Atoll (MV014)
//     MV014: {
//         name: "Thaa",
//         adminLevel: "atoll",
//         children: {
//             MV014001: { name: "Burunee", adminLevel: "island" },
//             MV014002: { name: "Vilufushi", adminLevel: "island" },
//             MV014003: { name: "Madifushi", adminLevel: "island" },
//             MV014004: { name: "Dhiyamigili", adminLevel: "island" },
//             MV014005: { name: "Guraidhoo", adminLevel: "island" },
//             MV014006: { name: "Kan'doodhoo", adminLevel: "island" },
//             MV014007: { name: "Vandhoo", adminLevel: "island" },
//             MV014008: { name: "Hirilandhoo", adminLevel: "island" },
//             MV014009: { name: "Gaadhiffushi", adminLevel: "island" },
//             MV014010: { name: "Thimarafushi", adminLevel: "island" },
//             MV014011: { name: "Veymandoo", adminLevel: "island" },
//             MV014012: { name: "Kin'bidhoo", adminLevel: "island" },
//             MV014013: { name: "Omadhoo", adminLevel: "island" },
//             MV014018: { name: "Dhururehaa", adminLevel: "island" },
//             MV014019: { name: "Ekuruffushi", adminLevel: "island" },
//             MV014020: { name: "Elaa", adminLevel: "island" },
//             MV014025: { name: "Funaddu", adminLevel: "island" },
//             MV014034: { name: "Kaaddoo", adminLevel: "island" },
//             MV014037: { name: "Kalhudheyfushi", adminLevel: "island" },
//             MV014041: { name: "Kanimeedhoo", adminLevel: "island" },
//             MV014064: { name: "Maalefushi", adminLevel: "island" },
//             MV014068: { name: "Olhufushi", adminLevel: "island" },
//             MV014069: { name: "Olhufushifinolhu", adminLevel: "island" },
//             MV014070: { name: "Olhugiri", adminLevel: "island" },
//             MV014072: { name: "Ruhthibirah", adminLevel: "island" }
//         }
//     },
//     // Laamu Atoll (MV015)
//     MV015: {
//         name: "Laamu",
//         adminLevel: "atoll",
//         children: {
//             MV015001: { name: "Isdhoo", adminLevel: "island" },
//             MV015002: { name: "Dhan'bidhoo", adminLevel: "island" },
//             MV015003: { name: "Maabaidhoo", adminLevel: "island" },
//             MV015004: { name: "Mundoo", adminLevel: "island" },
//             MV015005: { name: "Kalaidhoo", adminLevel: "island" },
//             MV015007: { name: "Maavah", adminLevel: "island" },
//             MV015008: { name: "Fonadhoo", adminLevel: "island" },
//             MV015009: { name: "Gaadhoo", adminLevel: "island" },
//             MV015010: { name: "Maamendhoo", adminLevel: "island" },
//             MV015011: { name: "Hithadhoo", adminLevel: "island" },
//             MV015012: { name: "Kunahandhoo", adminLevel: "island" },
//             MV015013: { name: "Gan", adminLevel: "island" },
//             MV015016: { name: "Baresdhoo", adminLevel: "island" },
//             MV015018: { name: "Bodufinolhu", adminLevel: "island" },
//             MV015019: { name: "Bodufinolhu", adminLevel: "island" },
//             MV015021: { name: "Boduhuraa", adminLevel: "island" },
//             MV015030: { name: "Fares", adminLevel: "island" },
//             MV015036: { name: "Guraidhoo", adminLevel: "island" },
//             MV015037: { name: "Haiythoshi", adminLevel: "island" },
//             MV015045: { name: "Kadhdhoo", adminLevel: "island" },
//             MV015048: { name: "Kandaru", adminLevel: "island" },
//             MV015050: { name: "Kashidhoo", adminLevel: "island" },
//             MV015053: { name: "Kudafushi", adminLevel: "island" },
//             MV015078: { name: "Maandhoo", adminLevel: "island" },
//             MV015080: { name: "Mahakanfushi", adminLevel: "island" },
//             MV015082: { name: "Mendhoo", adminLevel: "island" },
//             MV015084: { name: "Olhuveli", adminLevel: "island" },
//             MV015090: { name: "Vadinolhu", adminLevel: "island" }
//         }
//     },
//     // Gaafu Alifu Atoll (MV016)
//     MV016: {
//         name: "Gaafu Alifu",
//         adminLevel: "atoll",
//         children: {
//             MV016001: { name: "Kolamaafushi", adminLevel: "island" },
//             MV016002: { name: "Vilin'gili", adminLevel: "island" },
//             MV016003: { name: "Maamendhoo", adminLevel: "island" },
//             MV016004: { name: "Nilandhoo", adminLevel: "island" },
//             MV016005: { name: "Dhaandhoo", adminLevel: "island" },
//             MV016006: { name: "Dhevvadhoo", adminLevel: "island" },
//             MV016007: { name: "Kon'dey", adminLevel: "island" },
//             MV016009: { name: "Gemanafushi", adminLevel: "island" },
//             MV016010: { name: "Kan'duhulhudhoo", adminLevel: "island" },
//             MV016014: { name: "Bakehthaa", adminLevel: "island" },
//             MV016022: { name: "Dhevvalaabadhoo", adminLevel: "island" },
//             MV016024: { name: "Dhigurah", adminLevel: "island" },
//             MV016025: { name: "Falhumaafushi", adminLevel: "island" },
//             MV016031: { name: "Funadhoo", adminLevel: "island" },
//             MV016032: { name: "Funadhooviligillaa", adminLevel: "island" },
//             MV016033: { name: "Funamauddaa", adminLevel: "island" },
//             MV016035: { name: "Han'dahaa", adminLevel: "island" },
//             MV016036: { name: "Hinaamaagalaa", adminLevel: "island" },
//             MV016037: { name: "Hirihuttaa", adminLevel: "island" },
//             MV016039: { name: "Hithaadhoogalaa", adminLevel: "island" },
//             MV016048: { name: "Keredhdhoo", adminLevel: "island" },
//             MV016053: { name: "Kon'deymatheelaabadhoo", adminLevel: "island" },
//             MV016054: { name: "Kooddoo", adminLevel: "island" },
//             MV016066: { name: "LD1449", adminLevel: "island" },
//             MV016088: { name: "Maamutaa", adminLevel: "island" },
//             MV016089: { name: "Maarandhoo", adminLevel: "island" },
//             MV016090: { name: "Maarehaa", adminLevel: "island" },
//             MV016091: { name: "Mahahdhoo", adminLevel: "island" },
//             MV016099: { name: "Meradhoo", adminLevel: "island" },
//             MV016102: { name: "Raaverrehaa", adminLevel: "island" },
//             MV016104: { name: "Vodamulaa", adminLevel: "island" }
//         }
//     },
//     // Gaafu Dhaalu Atoll (MV017)
//     MV017: {
//         name: "Gaafu Dhaalu",
//         adminLevel: "atoll",
//         children: {
//             MV017001: { name: "Madaveli", adminLevel: "island" },
//             MV017002: { name: "Hoadehdhoo", adminLevel: "island" },
//             MV017003: { name: "Nadellaa", adminLevel: "island" },
//             MV017004: { name: "Gahdhoo", adminLevel: "island" },
//             MV017005: { name: "Rathafandhoo", adminLevel: "island" },
//             MV017006: { name: "Vaadhoo", adminLevel: "island" },
//             MV017007: { name: "Fiyoari", adminLevel: "island" },
//             MV017008: { name: "Faresmaathodaa", adminLevel: "island" },
//             MV017010: { name: "Thinadhoo", adminLevel: "island" },
//             MV017013: { name: "Kaadehdhoo", adminLevel: "island" },
//             MV017026: { name: "Bolimathaidhoo", adminLevel: "island" },
//             MV017034: { name: "Dhigurehaa", adminLevel: "island" },
//             MV017039: { name: "Dhoonirehaa", adminLevel: "island" },
//             MV017049: { name: "Farukolhuhuttaa", adminLevel: "island" },
//             MV017053: { name: "Fereythavilin'gili", adminLevel: "island" },
//             MV017058: { name: "Gazeeraa", adminLevel: "island" },
//             MV017069: { name: "Havoddaa", adminLevel: "island" },
//             MV017081: { name: "Kaashidhoo", adminLevel: "island" },
//             MV017083: { name: "Kadevaarehaa", adminLevel: "island" },
//             MV017084: { name: "Kadhefala", adminLevel: "island" },
//             MV017104: { name: "Kodurataa", adminLevel: "island" },
//             MV017105: { name: "Konottaa", adminLevel: "island" },
//             MV017112: { name: "Kudherataa", adminLevel: "island" },
//             MV017133: { name: "Lonudhoohuttaa", adminLevel: "island" },
//             MV017139: { name: "Maallaarehaa", adminLevel: "island" },
//             MV017143: { name: "Maavaaruloo", adminLevel: "island" },
//             MV017144: { name: "Maavehdhoo", adminLevel: "island" },
//             MV017145: { name: "Maguhdhuvaa", adminLevel: "island" },
//             MV017156: { name: "Olhimuntaa", adminLevel: "island" },
//             MV017160: { name: "Rahadhuvaa", adminLevel: "island" },
//             MV017169: { name: "Vatavarrehaa", adminLevel: "island" }
//         }
//     },
//     // Gnaviyani Atoll (MV018)
//     MV018: {
//         name: "Gnaviyani",
//         adminLevel: "atoll",
//         children: {
//             MV018001: { name: "Fuvahmulah", adminLevel: "island" }
//         }
//     },
//     // Seenu Atoll (MV019)
//     MV019: {
//         name: "Seenu",
//         adminLevel: "atoll",
//         children: {
//             MV019001: { name: "Meedhoo", adminLevel: "island" },
//             MV019002: { name: "Hithadhoo", adminLevel: "island" },
//             MV019003: { name: "Maradhoo", adminLevel: "island" },
//             MV019004: { name: "Feydhoo", adminLevel: "island" },
//             MV019005: { name: "Maradhoofeydhoo", adminLevel: "island" },
//             MV019006: { name: "Hulhudhoo", adminLevel: "island" },
//             MV019025: { name: "Vilin'gili", adminLevel: "island" },
//             MV019033: { name: "Gan", adminLevel: "island" },
//             MV019034: { name: "Geskalhuheraa", adminLevel: "island" },
//             MV019035: { name: "Gomahera", adminLevel: "island" },
//             MV019036: { name: "Hankede", adminLevel: "island" },
//             MV019038: { name: "Herethere", adminLevel: "island" },
//             MV019040: { name: "Ismehelaahera", adminLevel: "island" },
//             MV019057: { name: "Mulikede", adminLevel: "island" },
//             MV019058: { name: "Savaaheli", adminLevel: "island" }
//         }
//     },
//     // Alifu Dhaalu Atoll (MV020)
//     MV020: {
//         name: "Alifu Dhaalu",
//         adminLevel: "atoll",
//         children: {
//             MV020001: { name: "Hangnaameedhoo", adminLevel: "island" },
//             MV020002: { name: "Omadhoo", adminLevel: "island" },
//             MV020003: { name: "Kun'burudhoo", adminLevel: "island" },
//             MV020004: { name: "Mahibadhoo", adminLevel: "island" },
//             MV020005: { name: "Mandhoo", adminLevel: "island" },
//             MV020006: { name: "Dhan'gethi", adminLevel: "island" },
//             MV020007: { name: "Dhigurah", adminLevel: "island" },
//             MV020008: { name: "Fenfushi", adminLevel: "island" },
//             MV020009: { name: "Dhihdhoo", adminLevel: "island" },
//             MV020010: { name: "Maamin'gili", adminLevel: "island" },
//             MV020011: { name: "Angaagau", adminLevel: "island" },
//             MV020012: { name: "Ariyadhoo", adminLevel: "island" },
//             MV020014: { name: "Athurugau", adminLevel: "island" },
//             MV020015: { name: "Bodufinolhu", adminLevel: "island" },
//             MV020018: { name: "Dhiffushi", adminLevel: "island" },
//             MV020020: { name: "Dhihdhoofinolhu", adminLevel: "island" },
//             MV020023: { name: "Heenfaru", adminLevel: "island" },
//             MV020025: { name: "Hukurudhoo", adminLevel: "island" },
//             MV020027: { name: "Huruelhi", adminLevel: "island" },
//             MV020028: { name: "Huvahendhoo", adminLevel: "island" },
//             MV020029: { name: "Innafushi", adminLevel: "island" },
//             MV020032: { name: "Kudarah", adminLevel: "island" },
//             MV020067: { name: "Lonuboi", adminLevel: "island" },
//             MV020068: { name: "Maafushivaru", adminLevel: "island" },
//             MV020069: { name: "Mahchafushi", adminLevel: "island" },
//             MV020070: { name: "Mirihi", adminLevel: "island" },
//             MV020071: { name: "Moofushi", adminLevel: "island" },
//             MV020072: { name: "Nalaguraidhoo", adminLevel: "island" },
//             MV020074: { name: "Rangaleefinolhu", adminLevel: "island" },
//             MV020076: { name: "Theluveligaa", adminLevel: "island" },
//             MV020077: { name: "Tholhifushi", adminLevel: "island" },
//             MV020078: { name: "Thun'dufushi", adminLevel: "island" },
//             MV020079: { name: "Vakarufalhi", adminLevel: "island" },
//             MV020080: { name: "Vilamendhoo", adminLevel: "island" },
//             MV020081: { name: "Vilin'gilivaru", adminLevel: "island" }
//         }
//     },
//     // Male Atoll (MV021)
//     MV021: {
//         name: "Male",
//         adminLevel: "atoll",
//         children: {
//             MV021001: { name: "Maale", adminLevel: "island" },
//             MV021002: { name: "Vilin'gili", adminLevel: "island" },
//             MV021003: { name: "Hulhumaale", adminLevel: "island" }
//         }
//     }
// }

export const maldivesAdministrativeLevel: AdministrativeLevels = {
    // Haa Alifu Atoll (MV001)
    MV001: {
        name: "Haa Alifu",
        adminLevel: "atoll",
        children: {
            MV001020: { name: "Beenaafushi-Haa Alifu", adminLevel: "island" },
            MV001003: { name: "Berinmadhoo-Haa Alifu", adminLevel: "island" },
            MV001021: { name: "Dhapparuhuraa-Haa Alifu", adminLevel: "island" },
            MV001010: { name: "Dhidhdhoo-Haa Alifu", adminLevel: "island" },
            MV001022: { name: "Dhigufaruhuraa-Haa Alifu", adminLevel: "island" },
            MV001023: { name: "Dhonakulhi-Haa Alifu", adminLevel: "island" },
            MV001011: { name: "Filladhoo-Haa Alifu", adminLevel: "island" },
            MV001024: { name: "Gaamathikulhudhoo-Haa Alifu", adminLevel: "island" },
            MV001025: { name: "Gallandhoo-Haa Alifu", adminLevel: "island" },
            MV001026: { name: "Govvaafushi-Haa Alifu", adminLevel: "island" },
            MV001004: { name: "Hathifushi-Haa Alifu", adminLevel: "island" },
            MV001006: { name: "Hoarafushi-Haa Alifu", adminLevel: "island" },
            MV001027: { name: "Huvahandhoo-Haa Alifu", adminLevel: "island" },
            MV001007: { name: "Ihavandhoo-Haa Alifu", adminLevel: "island" },
            MV001028: { name: "Innafinolhu-Haa Alifu", adminLevel: "island" },
            MV001029: { name: "Kan'daalifinolhu-Haa Alifu", adminLevel: "island" },
            MV001008: { name: "Kelaa-Haa Alifu", adminLevel: "island" },
            MV001030: { name: "Kudafinolhu-Haa Alifu", adminLevel: "island" },
            MV001017: { name: "Maafahi-Haa Alifu", adminLevel: "island" },
            MV001032: { name: "Maafinolhu-Haa Alifu", adminLevel: "island" },
            MV001012: { name: "Maarandhoo-Haa Alifu", adminLevel: "island" },
            MV001033: { name: "Maarandhoofarufinolhu-Haa Alifu", adminLevel: "island" },
            MV001034: { name: "Madulu-Haa Alifu", adminLevel: "island" },
            MV001035: { name: "Manafaru-Haa Alifu", adminLevel: "island" },
            MV001036: { name: "Matheerah-Haa Alifu", adminLevel: "island" },
            MV001037: { name: "Medhafushi-Haa Alifu", adminLevel: "island" },
            MV001018: { name: "Alidhoo-Haa Alifu", adminLevel: "island" },
            MV001019: { name: "Alidhuffarufinolhu-Haa Alifu", adminLevel: "island" },
            MV001016: { name: "Baarah-Haa Alifu", adminLevel: "island" },
            MV001005: { name: "Molhadhoo-Haa Alifu", adminLevel: "island" },
            MV001038: { name: "Mulidhoo-Haa Alifu", adminLevel: "island" },
            MV001015: { name: "Muraidhoo-Haa Alifu", adminLevel: "island" },
            MV001039: { name: "Naridhoo-Haa Alifu", adminLevel: "island" },
            MV001013: { name: "Thakandhoo-Haa Alifu", adminLevel: "island" },
            MV001001: { name: "Thuraakunu-Haa Alifu", adminLevel: "island" },
            MV001002: { name: "Uligan-Haa Alifu", adminLevel: "island" },
            MV001040: { name: "Umuraifinolhu-Haa Alifu", adminLevel: "island" },
            MV001041: { name: "Un'gulifinolhu-Haa Alifu", adminLevel: "island" },
            MV001014: { name: "Utheemu-Haa Alifu", adminLevel: "island" },
            MV001042: { name: "Van'gaaru-Haa Alifu", adminLevel: "island" },
            MV001009: { name: "Vashafaru-Haa Alifu", adminLevel: "island" },
            MV001043: { name: "Velifinolhu-Haa Alifu", adminLevel: "island" },
        }
    },
    // Haa Dhaalu Atoll (MV002)
    MV002: {
        name: "Haa Dhaalu",
        adminLevel: "atoll",
        children: {
            MV002018: { name: "Dhipparufushi-Haa Dhaalu", adminLevel: "island" },
            MV002001: { name: "Faridhoo-Haa Dhaalu", adminLevel: "island" },
            MV002019: { name: "Fenboahuraa-Haa Dhaalu", adminLevel: "island" },
            MV002004: { name: "Finey-Haa Dhaalu", adminLevel: "island" },
            MV002003: { name: "Hanimaadhoo-Haa Dhaalu", adminLevel: "island" },
            MV002006: { name: "Hirimaradhoo-Haa Dhaalu", adminLevel: "island" },
            MV002020: { name: "Hirinaidhoo-Haa Dhaalu", adminLevel: "island" },
            MV002022: { name: "Innafushi-Haa Dhaalu", adminLevel: "island" },
            MV002021: { name: "Hon'daafushi-Haa Dhaalu", adminLevel: "island" },
            MV002002: { name: "Hon'daidhoo-Haa Dhaalu", adminLevel: "island" },
            MV002023: { name: "Kanamana-Haa Dhaalu", adminLevel: "island" },
            MV002024: { name: "Kattalafushi-Haa Dhaalu", adminLevel: "island" },
            MV002025: { name: "Keylakunu-Haa Dhaalu", adminLevel: "island" },
            MV002026: { name: "Kudafarufasgandu-Haa Dhaalu", adminLevel: "island" },
            MV002027: { name: "Kudamuraidhoo-Haa Dhaalu", adminLevel: "island" },
            MV002012: { name: "Kulhudhuffushi-Haa Dhaalu", adminLevel: "island" },
            MV002013: { name: "Kumundhoo-Haa Dhaalu", adminLevel: "island" },
            MV002011: { name: "Kun'burudhoo-Haa Dhaalu", adminLevel: "island" },
            MV002028: { name: "Kuredhigan'du-Haa Dhaalu", adminLevel: "island" },
            MV002010: { name: "Kurin'bi-Haa Dhaalu", adminLevel: "island" },
            MV002016: { name: "Maavaidhoo-Haa Dhaalu", adminLevel: "island" },
            MV002017: { name: "Makunudhoo-Haa Dhaalu", adminLevel: "island" },
            MV002031: { name: "Muiri-Haa Dhaalu", adminLevel: "island" },
            MV002032: { name: "Naagoashi-Haa Dhaalu", adminLevel: "island" },
            MV002005: { name: "Naivaadhoo-Haa Dhaalu", adminLevel: "island" },
            MV002008: { name: "Nellaidhoo-Haa Dhaalu", adminLevel: "island" },
            MV002014: { name: "Neykurendhoo-Haa Dhaalu", adminLevel: "island" },
            MV002009: { name: "Nolhivaran-Haa Dhaalu", adminLevel: "island" },
            MV002007: { name: "Nolhivaranfaru-Haa Dhaalu", adminLevel: "island" },
            MV002033: { name: "Ruffushi-Haa Dhaalu", adminLevel: "island" },
            MV002034: { name: "Theefaridhoo-Haa Dhaalu", adminLevel: "island" },
            MV002015: { name: "Vaikaradhoo-Haa Dhaalu", adminLevel: "island" },
            MV002035: { name: "Vaikaramuraidhoo-Haa Dhaalu", adminLevel: "island" },
            MV002036: { name: "Veligan'du-Haa Dhaalu", adminLevel: "island" },
        }
    },
    // Shaviyani Atoll (MV003)
    MV003: {
        name: "Shaviyani",
        adminLevel: "atoll",
        children: {
            MV003006: { name: "Bileiyfahi-Shaviyani", adminLevel: "island" },
            MV003017: { name: "Bis Alhaahuraa-Shaviyani", adminLevel: "island" },
            MV003018: { name: "Boduhuraa-Shaviyani", adminLevel: "island" },
            MV003019: { name: "Bolissafaru-Shaviyani", adminLevel: "island" },
            MV003020: { name: "Dhigurah-Shaviyani", adminLevel: "island" },
            MV003021: { name: "Dhiguvelidhoomairah-Shaviyani", adminLevel: "island" },
            MV003022: { name: "Dholhiyadhoo-Shaviyani", adminLevel: "island" },
            MV003023: { name: "Dholhiyadhookudarah-Shaviyani", adminLevel: "island" },
            MV003024: { name: "Dhonvelihuraa-Shaviyani", adminLevel: "island" },
            MV003025: { name: "Ekasdhoo-Shaviyani", adminLevel: "island" },
            MV003026: { name: "Eriadhoo-Shaviyani", adminLevel: "island" },
            MV003027: { name: "Farukolhu-Shaviyani", adminLevel: "island" },
            MV003005: { name: "Feevah-Shaviyani", adminLevel: "island" },
            MV003004: { name: "Feydhoo-Shaviyani", adminLevel: "island" },
            MV003007: { name: "Foakaidhoo-Shaviyani", adminLevel: "island" },
            MV003015: { name: "Funadhoo-Shaviyani", adminLevel: "island" },
            MV003028: { name: "Fushifaru-Shaviyani", adminLevel: "island" },
            MV003029: { name: "Gaakoshibi-Shaviyani", adminLevel: "island" },
            MV003030: { name: "Gallaidhoo-Shaviyani", adminLevel: "island" },
            MV003003: { name: "Goidhoo-Shaviyani", adminLevel: "island" },
            MV003031: { name: "Hirubadhoo-Shaviyani", adminLevel: "island" },
            MV003032: { name: "Hurasfaru-Shaviyani", adminLevel: "island" },
            MV003033: { name: "Kakaaeriyadhoo-Shaviyani", adminLevel: "island" },
            MV003035: { name: "Keekimini-Shaviyani", adminLevel: "island" },
            MV003013: { name: "Komandoo-Shaviyani", adminLevel: "island" },
            MV003036: { name: "Kudadhoo-Shaviyani", adminLevel: "island" },
            MV003037: { name: "Kudafarufinolhu-Shaviyani", adminLevel: "island" },
            MV003038: { name: "Kudalhaimendhoo-Shaviyani", adminLevel: "island" },
            MV003011: { name: "Lhaimagu-Shaviyani", adminLevel: "island" },
            MV003047: { name: "Madidhoo-Shaviyani", adminLevel: "island" },
            MV003048: { name: "Madikuredhdhoo-Shaviyani", adminLevel: "island" },
            MV003001: { name: "Kan'ditheemu-Shaviyani", adminLevel: "island" },
            MV003010: { name: "Maroshi-Shaviyani", adminLevel: "island" },
            MV003012: { name: "Firun'baidhoo-Shaviyani", adminLevel: "island" },
            MV003034: { name: "Kan'baalifaru-Shaviyani", adminLevel: "island" },
            MV003014: { name: "Maaun'goodhoo-Shaviyani", adminLevel: "island" },
            MV003049: { name: "Mathikomandoo-Shaviyani", adminLevel: "island" },
            MV003009: { name: "Maakan'doodhoo-Shaviyani", adminLevel: "island" },
            MV003050: { name: "Medhukun'burudhoo-Shaviyani", adminLevel: "island" },
            MV003051: { name: "Medhurah-Shaviyani", adminLevel: "island" },
            MV003052: { name: "Migoodhoo-Shaviyani", adminLevel: "island" },
            MV003016: { name: "Milandhoo-Shaviyani", adminLevel: "island" },
            MV003053: { name: "Naainfarufinolhu-Shaviyani", adminLevel: "island" },
            MV003054: { name: "Naalaahuraa-Shaviyani", adminLevel: "island" },
            MV003055: { name: "Nalandhoo-Shaviyani", adminLevel: "island" },
            MV003008: { name: "Narudhoo-Shaviyani", adminLevel: "island" },
            MV003056: { name: "Narurin'budhoo-Shaviyani", adminLevel: "island" },
            MV003057: { name: "Neyo-Shaviyani", adminLevel: "island" },
            MV003002: { name: "Noomaraa-Shaviyani", adminLevel: "island" },
            MV003058: { name: "Raggan'duhuraa-Shaviyani", adminLevel: "island" },
            MV003059: { name: "Van'garu-Shaviyani", adminLevel: "island" },
        }
    },
    // Noonu Atoll (MV004)
    MV004: {
        name: "Noonu",
        adminLevel: "atoll",
        children: {
            MV004015: { name: "Bodufushi-Noonu", adminLevel: "island" },
            MV004016: { name: "Bodulhaimendhoo-Noonu", adminLevel: "island" },
            MV004017: { name: "Bomasdhoo-Noonu", adminLevel: "island" },
            MV004018: { name: "Burehifasdhoo-Noonu", adminLevel: "island" },
            MV004019: { name: "Dheefuram-Noonu", adminLevel: "island" },
            MV004020: { name: "Dhekenanfaru-Noonu", adminLevel: "island" },
            MV004021: { name: "Dhelibeyruhelhihuraa-Noonu", adminLevel: "island" },
            MV004022: { name: "Dhigurah-Noonu", adminLevel: "island" },
            MV004024: { name: "Ehdhuffarumairah-Noonu", adminLevel: "island" },
            MV004025: { name: "Ekulhivaru-Noonu", adminLevel: "island" },
            MV004026: { name: "Farumuli-Noonu", adminLevel: "island" },
            MV004027: { name: "Felivaru-Noonu", adminLevel: "island" },
            MV004012: { name: "Fodhdhoo-Noonu", adminLevel: "island" },
            MV004028: { name: "Fohdhipparu-Noonu", adminLevel: "island" },
            MV004029: { name: "Fushivelavaru-Noonu", adminLevel: "island" },
            MV004011: { name: "Holhudhoo-Noonu", adminLevel: "island" },
            MV004031: { name: "Huivani-Noonu", adminLevel: "island" },
            MV004032: { name: "Hulhuhdhoo-Noonu", adminLevel: "island" },
            MV004035: { name: "Kaalhugemendhoo-Noonu", adminLevel: "island" },
            MV004036: { name: "Kafakomandoo-Noonu", adminLevel: "island" },
            MV004037: { name: "Kalaidhoo-Noonu", adminLevel: "island" },
            MV004039: { name: "Karinma-Noonu", adminLevel: "island" },
            MV004040: { name: "Karinmavattaru-Noonu", adminLevel: "island" },
            MV004041: { name: "Kedhivaru-Noonu", adminLevel: "island" },
            MV004004: { name: "Kudafari-Noonu", adminLevel: "island" },
            MV004042: { name: "Kudafunafaru-Noonu", adminLevel: "island" },
            MV004043: { name: "Kudafushi-Noonu", adminLevel: "island" },
            MV004044: { name: "Kunnamalei-Noonu", adminLevel: "island" },
            MV004045: { name: "Kuramaadhoo-Noonu", adminLevel: "island" },
            MV004046: { name: "Kuredhivaru-Noonu", adminLevel: "island" },
            MV004005: { name: "Landhoo-Noonu", adminLevel: "island" },
            MV004007: { name: "Lhohi-Noonu", adminLevel: "island" },
            MV004061: { name: "Loafaru-Noonu", adminLevel: "island" },
            MV004001: { name: "Hen'badhoo-Noonu", adminLevel: "island" },
            MV004002: { name: "Ken'dhikulhudhoo-Noonu", adminLevel: "island" },
            MV004014: { name: "Ban'daidhihdhoo-Noonu", adminLevel: "island" },
            MV004033: { name: "Huvan'dhumaavattaru-Noonu", adminLevel: "island" },
            MV004006: { name: "Maafaru-Noonu", adminLevel: "island" },
            MV004062: { name: "Maafunafaru-Noonu", adminLevel: "island" },
            MV004023: { name: "Dhonaerikan'doodhoo-Noonu", adminLevel: "island" },
            MV004030: { name: "Goan'bilivaadhoo-Noonu", adminLevel: "island" },
            MV004034: { name: "In'guraidhoo-Noonu", adminLevel: "island" },
            MV004063: { name: "Maakanaafushi-Noonu", adminLevel: "island" },
            MV004064: { name: "Maakurehdhoo-Noonu", adminLevel: "island" },
            MV004038: { name: "Kan'dinmaahuraa-Noonu", adminLevel: "island" },
            MV004003: { name: "Maalhendhoo-Noonu", adminLevel: "island" },
            MV004065: { name: "Maavahdhoo-Noonu", adminLevel: "island" },
            MV004066: { name: "Maavelavaru-Noonu", adminLevel: "island" },
            MV004009: { name: "Magoodhoo-Noonu", adminLevel: "island" },
            MV004010: { name: "Manadhoo-Noonu", adminLevel: "island" },
            MV004067: { name: "Medhafushi-Noonu", adminLevel: "island" },
            MV004068: { name: "Medhufaru-Noonu", adminLevel: "island" },
            MV004008: { name: "Miladhoo-Noonu", adminLevel: "island" },
            MV004069: { name: "Minaavaru-Noonu", adminLevel: "island" },
            MV004070: { name: "Orimasvaru-Noonu", adminLevel: "island" },
            MV004071: { name: "Orivaru-Noonu", adminLevel: "island" },
            MV004072: { name: "Orivarukudarah-Noonu", adminLevel: "island" },
            MV004073: { name: "Raafushi-Noonu", adminLevel: "island" },
            MV004074: { name: "Raalhulaakolhu-Noonu", adminLevel: "island" },
            MV004075: { name: "Randheli-Noonu", adminLevel: "island" },
            MV004076: { name: "Than'burudhoo-Noonu", adminLevel: "island" },
            MV004077: { name: "Than'burudhuffushi-Noonu", adminLevel: "island" },
            MV004078: { name: "Tholhendhoo-Noonu", adminLevel: "island" },
            MV004079: { name: "Thoshigan'dukolhu-Noonu", adminLevel: "island" },
            MV004080: { name: "Vavathi-Noonu", adminLevel: "island" },
            MV004013: { name: "Velidhoo-Noonu", adminLevel: "island" },
        }
    },
    // Lhaviyani Atoll (MV005)
    MV005: {
        name: "Lhaviyani",
        adminLevel: "atoll",
        children: {
            MV005008: { name: "Bodufaahuraa-Lhaviyani", adminLevel: "island" },
            MV005009: { name: "Bodufinolhu-Lhaviyani", adminLevel: "island" },
            MV005010: { name: "Dhashugirifinolhu-Lhaviyani", adminLevel: "island" },
            MV005011: { name: "Dhehuraa Evvihuraa-Lhaviyani", adminLevel: "island" },
            MV005012: { name: "Dheruffinolhu-Lhaviyani", adminLevel: "island" },
            MV005013: { name: "Dhiffushi-Lhaviyani", adminLevel: "island" },
            MV005014: { name: "Dhihdhoo-Lhaviyani", adminLevel: "island" },
            MV005016: { name: "Faadhoo-Lhaviyani", adminLevel: "island" },
            MV005018: { name: "Fainuaadhanuhuraa-Lhaviyani", adminLevel: "island" },
            MV005019: { name: "Fehigili-Lhaviyani", adminLevel: "island" },
            MV005020: { name: "Felivaru-Lhaviyani", adminLevel: "island" },
            MV005021: { name: "Fushifaru-Lhaviyani", adminLevel: "island" },
            MV005022: { name: "Gaaerifaru-Lhaviyani", adminLevel: "island" },
            MV005023: { name: "Govvaafushi-Lhaviyani", adminLevel: "island" },
            MV005001: { name: "Hinnavaru-Lhaviyani", adminLevel: "island" },
            MV005024: { name: "Hiriyadhoo-Lhaviyani", adminLevel: "island" },
            MV005025: { name: "Hudhufushi-Lhaviyani", adminLevel: "island" },
            MV005026: { name: "Huravalhi-Lhaviyani", adminLevel: "island" },
            MV005027: { name: "Innahuraa-Lhaviyani", adminLevel: "island" },
            MV005028: { name: "Kalhumanjehuraa-Lhaviyani", adminLevel: "island" },
            MV005029: { name: "Kanifushi-Lhaviyani", adminLevel: "island" },
            MV005030: { name: "Kanuhuraa-Lhaviyani", adminLevel: "island" },
            MV005031: { name: "Komandoo-Lhaviyani", adminLevel: "island" },
            MV005032: { name: "Kudadhoo-Lhaviyani", adminLevel: "island" },
            MV005007: { name: "Boamandhipparu Huraagan'du-Lhaviyani", adminLevel: "island" },
            MV005015: { name: "Dhirun'baahuraa-Lhaviyani", adminLevel: "island" },
            MV005017: { name: "Faadhoohuraagan'du-Lhaviyani", adminLevel: "island" },
            MV005033: { name: "Kurehdhoo-Lhaviyani", adminLevel: "island" },
            MV005003: { name: "Kurendhoo-Lhaviyani", adminLevel: "island" },
            MV005061: { name: "Lhohi-Lhaviyani", adminLevel: "island" },
            MV005062: { name: "Lhossalafushi-Lhaviyani", adminLevel: "island" },
            MV005063: { name: "Maabinhuraa-Lhaviyani", adminLevel: "island" },
            MV005005: { name: "Maafilaafushi-Lhaviyani", adminLevel: "island" },
            MV005064: { name: "Maakoa-Lhaviyani", adminLevel: "island" },
            MV005065: { name: "Madhiriguraidhoo-Lhaviyani", adminLevel: "island" },
            MV005066: { name: "Madivaru-Lhaviyani", adminLevel: "island" },
            MV005067: { name: "Maduvvari-Lhaviyani", adminLevel: "island" },
            MV005068: { name: "Maidhoo-Lhaviyani", adminLevel: "island" },
            MV005069: { name: "Masleggihuraa-Lhaviyani", adminLevel: "island" },
            MV005070: { name: "Medha Adihuraa-Lhaviyani", adminLevel: "island" },
            MV005071: { name: "Medhafushi-Lhaviyani", adminLevel: "island" },
            MV005072: { name: "Meedhaahuraa-Lhaviyani", adminLevel: "island" },
            MV005006: { name: "Aligau-Lhaviyani", adminLevel: "island" },
            MV005073: { name: "Meyyafushi-Lhaviyani", adminLevel: "island" },
            MV005002: { name: "Naifaru-Lhaviyani", adminLevel: "island" },
            MV005004: { name: "Olhuvelifushi-Lhaviyani", adminLevel: "island" },
            MV005074: { name: "Ookolhufinolhu-Lhaviyani", adminLevel: "island" },
            MV005075: { name: "Sehlhifushi-Lhaviyani", adminLevel: "island" },
            MV005076: { name: "Thilamaafushi-Lhaviyani", adminLevel: "island" },
            MV005077: { name: "Varihuraa-Lhaviyani", adminLevel: "island" },
            MV005078: { name: "Vavvaru-Lhaviyani", adminLevel: "island" },
            MV005079: { name: "Veligan'du-Lhaviyani", adminLevel: "island" },
            MV005080: { name: "Veyvah-Lhaviyani", adminLevel: "island" },
            MV005081: { name: "Vihafarufinolhu-Lhaviyani", adminLevel: "island" },
        }
    },
    // Raa Atoll (MV006)
    MV006: {
        name: "Raa",
        adminLevel: "atoll",
        children: {
            MV006024: { name: "Bodufarufinolhu-Raa", adminLevel: "island" },
            MV006026: { name: "Bodufushi-Raa", adminLevel: "island" },
            MV006027: { name: "Boduhaiykodi-Raa", adminLevel: "island" },
            MV006020: { name: "Aarah-Raa", adminLevel: "island" },
            MV006016: { name: "Boduhuraa-Raa", adminLevel: "island" },
            MV006028: { name: "Dheburidheythereyvaadhoo-Raa", adminLevel: "island" },
            MV006029: { name: "Dhekunumaafarufinolhu-Raa", adminLevel: "island" },
            MV006030: { name: "Dhigali-Raa", adminLevel: "island" },
            MV006007: { name: "Kan'dholhudhoo-Raa", adminLevel: "island" },
            MV006031: { name: "Dhikkurehdhoo-Raa", adminLevel: "island" },
            MV006032: { name: "Dhinnaafushi-Raa", adminLevel: "island" },
            MV006033: { name: "Dhoragali-Raa", adminLevel: "island" },
            MV006019: { name: "Dhuvaafaru-Raa", adminLevel: "island" },
            MV006034: { name: "Dhuvaafaruhuraa-Raa", adminLevel: "island" },
            MV006035: { name: "Ehthigili-Raa", adminLevel: "island" },
            MV006037: { name: "Faarufushi-Raa", adminLevel: "island" },
            MV006013: { name: "Fainu-Raa", adminLevel: "island" },
            MV006039: { name: "Fasmendhoo-Raa", adminLevel: "island" },
            MV006040: { name: "Fenfushi-Raa", adminLevel: "island" },
            MV006041: { name: "Filaidhoo-Raa", adminLevel: "island" },
            MV006042: { name: "Fuggiri-Raa", adminLevel: "island" },
            MV006043: { name: "Furaveri-Raa", adminLevel: "island" },
            MV006044: { name: "Gemana-Raa", adminLevel: "island" },
            MV006045: { name: "Giraavaru-Raa", adminLevel: "island" },
            MV006046: { name: "Goboshi-Raa", adminLevel: "island" },
            MV006047: { name: "Goiymaru-Raa", adminLevel: "island" },
            MV006048: { name: "Goyyafaru-Raa", adminLevel: "island" },
            MV006049: { name: "Hiboodhoo-Raa", adminLevel: "island" },
            MV006050: { name: "Hiraveri-Raa", adminLevel: "island" },
            MV006051: { name: "Hulhudhoo-Raa", adminLevel: "island" },
            MV006005: { name: "Hulhudhuffaaru-Raa", adminLevel: "island" },
            MV006052: { name: "Huruvalhi-Raa", adminLevel: "island" },
            MV006053: { name: "Ifuru-Raa", adminLevel: "island" },
            MV006010: { name: "Innamaadhoo-Raa", adminLevel: "island" },
            MV006015: { name: "Kinolhas-Raa", adminLevel: "island" },
            MV006056: { name: "Kothaifaru-Raa", adminLevel: "island" },
            MV006057: { name: "Kottefaru-Raa", adminLevel: "island" },
            MV006059: { name: "Kudafushi-Raa", adminLevel: "island" },
            MV006060: { name: "Kudakurathu-Raa", adminLevel: "island" },
            MV006061: { name: "Kudalhosgiri-Raa", adminLevel: "island" },
            MV006062: { name: "Kudathulhaadhoo-Raa", adminLevel: "island" },
            MV006063: { name: "Kukulhudhoo-Raa", adminLevel: "island" },
            MV006064: { name: "Kukulhudhuffaru-Raa", adminLevel: "island" },
            MV006065: { name: "Kurehdhoo-Raa", adminLevel: "island" },
            MV006066: { name: "Kuroshigiri-Raa", adminLevel: "island" },
            MV006093: { name: "Lhohi-Raa", adminLevel: "island" },
            MV006008: { name: "Maakurathu-Raa", adminLevel: "island" },
            MV006004: { name: "An'golhitheemu-Raa", adminLevel: "island" },
            MV006012: { name: "In'guraidhoo-Raa", adminLevel: "island" },
            MV006097: { name: "Maamunagau-Raa", adminLevel: "island" },
            MV006098: { name: "Maamunagaufinolhu-Raa", adminLevel: "island" },
            MV006017: { name: "Gaaun'doodhoo-Raa", adminLevel: "island" },
            MV006055: { name: "Kan'doogan'du-Raa", adminLevel: "island" },
            MV006099: { name: "Maanenfushi-Raa", adminLevel: "island" },
            MV006100: { name: "Maashigiri-Raa", adminLevel: "island" },
            MV006094: { name: "Lin'boakandhoo-Raa", adminLevel: "island" },
            MV006095: { name: "Lun'dhufushi-Raa", adminLevel: "island" },
            MV006096: { name: "Maamin'gili-Raa", adminLevel: "island" },
            MV006101: { name: "Madivaafaru-Raa", adminLevel: "island" },
            MV006023: { name: "Ban'daveri-Raa", adminLevel: "island" },
            MV006025: { name: "Bodufenmaaen'boodhoo-Raa", adminLevel: "island" },
            MV006038: { name: "Fasgan'dufaru-Raa", adminLevel: "island" },
            MV006054: { name: "Kandhoomeehunge Lhaan'bugali-Raa", adminLevel: "island" },
            MV006058: { name: "Kudafenmaaen'boodhoo-Raa", adminLevel: "island" },
            MV006092: { name: "Lhaan'bugali-Raa", adminLevel: "island" },
            MV006036: { name: "Ethigan'dujehihuraa-Raa", adminLevel: "island" },
            MV006011: { name: "Maduvvari-Raa", adminLevel: "island" },
            MV006102: { name: "Mahidhoo-Raa", adminLevel: "island" },
            MV006001: { name: "Alifushi-Raa", adminLevel: "island" },
            MV006103: { name: "Meedhupparu-Raa", adminLevel: "island" },
            MV006104: { name: "Minaadhoo-Raa", adminLevel: "island" },
            MV006022: { name: "Arilundhoo-Raa", adminLevel: "island" },
            MV006014: { name: "Meedhoo-Raa", adminLevel: "island" },
            MV006105: { name: "Mullaafushi-Raa", adminLevel: "island" },
            MV006106: { name: "Muravandhoo-Raa", adminLevel: "island" },
            MV006107: { name: "Neyo-Raa", adminLevel: "island" },
            MV006108: { name: "Orimasfushi-Raa", adminLevel: "island" },
            MV006003: { name: "Rasgetheemu-Raa", adminLevel: "island" },
            MV006009: { name: "Rasmaadhoo-Raa", adminLevel: "island" },
            MV006109: { name: "Thaavathaa-Raa", adminLevel: "island" },
            MV006110: { name: "Ufulandhoo-Raa", adminLevel: "island" },
            MV006006: { name: "Un'goofaaru-Raa", adminLevel: "island" },
            MV006018: { name: "Un'gulu-Raa", adminLevel: "island" },
            MV006111: { name: "Uthurumaafaru-Raa", adminLevel: "island" },
            MV006002: { name: "Vaadhoo-Raa", adminLevel: "island" },
            MV006112: { name: "Vaffushi-Raa", adminLevel: "island" },
            MV006113: { name: "Vaffushihuraa-Raa", adminLevel: "island" },
            MV006114: { name: "Vakkarufaru-Raa", adminLevel: "island" },
            MV006021: { name: "Angaagiri-Raa", adminLevel: "island" },
            MV006115: { name: "Vandhoo-Raa", adminLevel: "island" },
            MV006116: { name: "Veyvah-Raa", adminLevel: "island" },
            MV006117: { name: "Vilin'gili-Raa", adminLevel: "island" },
        }
    },
    // Baa Atoll (MV007)
    MV007: {
        name: "Baa",
        adminLevel: "atoll",
        children: {
            MV007018: { name: "Bathalaa-Baa", adminLevel: "island" },
            MV007019: { name: "Bathalaahuraa-Baa", adminLevel: "island" },
            MV007020: { name: "Boadhaafushifinolhu-Baa", adminLevel: "island" },
            MV007016: { name: "An'gaafaru-Baa", adminLevel: "island" },
            MV007021: { name: "Bodufinolhu-Baa", adminLevel: "island" },
            MV007022: { name: "Boifushi-Baa", adminLevel: "island" },
            MV007023: { name: "Dhakandhoo-Baa", adminLevel: "island" },
            MV007024: { name: "Dhandhoo-Baa", adminLevel: "island" },
            MV007006: { name: "Dharavandhoo-Baa", adminLevel: "island" },
            MV007025: { name: "Dhashufaruhuraa-Baa", adminLevel: "island" },
            MV007026: { name: "Dhigudhefaru-Baa", adminLevel: "island" },
            MV007027: { name: "Dhigufaruvinagan'du-Baa", adminLevel: "island" },
            MV007005: { name: "Dhonfan-Baa", adminLevel: "island" },
            MV007028: { name: "Dhoogan'dufinolhu-Baa", adminLevel: "island" },
            MV007029: { name: "Dhunikolhu-Baa", adminLevel: "island" },
            MV007030: { name: "En'boodhoo-Baa", adminLevel: "island" },
            MV007008: { name: "Eydhafushi-Baa", adminLevel: "island" },
            MV007012: { name: "Fehendhoo-Baa", adminLevel: "island" },
            MV007032: { name: "Finolhas-Baa", adminLevel: "island" },
            MV007033: { name: "Finolhufaru-Baa", adminLevel: "island" },
            MV007034: { name: "Fonimagoodhoo-Baa", adminLevel: "island" },
            MV007011: { name: "Fulhadhoo-Baa", adminLevel: "island" },
            MV007036: { name: "Gaagan'dufaruhuraa-Baa", adminLevel: "island" },
            MV007037: { name: "Gaavilin'gili-Baa", adminLevel: "island" },
            MV007038: { name: "Gemendhoo-Baa", adminLevel: "island" },
            MV007013: { name: "Goidhoo-Baa", adminLevel: "island" },
            MV007039: { name: "Hanifaru-Baa", adminLevel: "island" },
            MV007040: { name: "Hanifaruhuraa-Baa", adminLevel: "island" },
            MV007031: { name: "Fares-Baa", adminLevel: "island" },
            MV007041: { name: "Hibalhidhoo-Baa", adminLevel: "island" },
            MV007042: { name: "Hirundhoo-Baa", adminLevel: "island" },
            MV007010: { name: "Hithaadhoo-Baa", adminLevel: "island" },
            MV007043: { name: "Horubadhoo-Baa", adminLevel: "island" },
            MV007109: { name: "Olhugiri-Baa", adminLevel: "island" },
            MV007044: { name: "Hulhudhoo-Baa", adminLevel: "island" },
            MV007045: { name: "Huraafaru-Baa", adminLevel: "island" },
            MV007046: { name: "Innafushi-Baa", adminLevel: "island" },
            MV007002: { name: "Kamadhoo-Baa", adminLevel: "island" },
            MV007047: { name: "Kanufusheegaathufinolhu-Baa", adminLevel: "island" },
            MV007048: { name: "Kanufushi-Baa", adminLevel: "island" },
            MV007049: { name: "Kashidhoo-Baa", adminLevel: "island" },
            MV007050: { name: "Keyodhoo-Baa", adminLevel: "island" },
            MV007004: { name: "Kihaadhoo-Baa", adminLevel: "island" },
            MV007051: { name: "Kihaadhuffaru-Baa", adminLevel: "island" },
            MV007052: { name: "Kihavahhuravalhi-Baa", adminLevel: "island" },
            MV007053: { name: "Kudadhoo-Baa", adminLevel: "island" },
            MV007001: { name: "Kudarikilu-Baa", adminLevel: "island" },
            MV007054: { name: "Kunfunadhoo-Baa", adminLevel: "island" },
            MV007055: { name: "Lan'daagiraavaru-Baa", adminLevel: "island" },
            MV007094: { name: "Maaddoo-Baa", adminLevel: "island" },
            MV007095: { name: "Maaddoohulhudhoo-Baa", adminLevel: "island" },
            MV007096: { name: "Maafusheefinolhu-Baa", adminLevel: "island" },
            MV007007: { name: "Maalhos-Baa", adminLevel: "island" },
            MV007097: { name: "Maamaduvvari-Baa", adminLevel: "island" },
            MV007098: { name: "Maarikilu-Baa", adminLevel: "island" },
            MV007099: { name: "Madhirivaadhoo-Baa", adminLevel: "island" },
            MV007100: { name: "Mathifaru-Baa", adminLevel: "island" },
            MV007101: { name: "Medhufinolhugaathufinolhu-Baa", adminLevel: "island" },
            MV007014: { name: "Ahivaffushi-Baa", adminLevel: "island" },
            MV007015: { name: "Aidhoo-Baa", adminLevel: "island" },
            MV007035: { name: "Funadhoo-Baa", adminLevel: "island" },
            MV007003: { name: "Kendhoo-Baa", adminLevel: "island" },
            MV007102: { name: "Mendhoo-Baa", adminLevel: "island" },
            MV007103: { name: "Milaidhoo-Baa", adminLevel: "island" },
            MV007017: { name: "Anhenunfushi-Baa", adminLevel: "island" },
            MV007104: { name: "Miriandhoo-Baa", adminLevel: "island" },
            MV007105: { name: "Mudhdhoo-Baa", adminLevel: "island" },
            MV007106: { name: "Muthaafushi-Baa", adminLevel: "island" },
            MV007107: { name: "Nelivarufinolhu-Baa", adminLevel: "island" },
            MV007108: { name: "Nibiligaa-Baa", adminLevel: "island" },
            MV007110: { name: "Thiladhoo-Baa", adminLevel: "island" },
            MV007009: { name: "Thulhaadhoo-Baa", adminLevel: "island" },
            MV007111: { name: "Ufuligiri-Baa", adminLevel: "island" },
            MV007113: { name: "Vakkaru-Baa", adminLevel: "island" },
            MV007112: { name: "Un'doodhoo-Baa", adminLevel: "island" },
            MV007114: { name: "Vandhuhmaafarufinolhu-Baa", adminLevel: "island" },
            MV007115: { name: "Velavaru-Baa", adminLevel: "island" },
            MV007116: { name: "Veyofushi-Baa", adminLevel: "island" },
            MV007117: { name: "Vinaneiyfaruhuraa-Baa", adminLevel: "island" },
            MV007118: { name: "Voavah-Baa", adminLevel: "island" },
        }
    },
    // Alifu Alifu Atoll (MV008)
    MV008: {
        name: "Alifu Alifu",
        adminLevel: "atoll",
        children: {
            MV008011: { name: "Bathalaa-Alifu Alifu", adminLevel: "island" },
            MV008005: { name: "Bodufolhudhoo-Alifu Alifu", adminLevel: "island" },
            MV008012: { name: "Dhinnolhufinolhu-Alifu Alifu", adminLevel: "island" },
            MV008013: { name: "Ellaidhoo-Alifu Alifu", adminLevel: "island" },
            MV008014: { name: "Etheremadivaru-Alifu Alifu", adminLevel: "island" },
            MV008006: { name: "Feridhoo-Alifu Alifu", adminLevel: "island" },
            MV008015: { name: "Fesdhoo-Alifu Alifu", adminLevel: "island" },
            MV008016: { name: "Fusfinolhu-Alifu Alifu", adminLevel: "island" },
            MV008017: { name: "Fushi-Alifu Alifu", adminLevel: "island" },
            MV008018: { name: "Gaagan'du-Alifu Alifu", adminLevel: "island" },
            MV008019: { name: "Gaathafushi-Alifu Alifu", adminLevel: "island" },
            MV008020: { name: "Gangehi-Alifu Alifu", adminLevel: "island" },
            MV008021: { name: "Halaveli-Alifu Alifu", adminLevel: "island" },
            MV008008: { name: "Himandhoo-Alifu Alifu", adminLevel: "island" },
            MV008022: { name: "Kan'dholhudhoo-Alifu Alifu", adminLevel: "island" },
            MV008023: { name: "Kudafolhudhoo-Alifu Alifu", adminLevel: "island" },
            MV008024: { name: "Kuramathi-Alifu Alifu", adminLevel: "island" },
            MV008037: { name: "Maagau-Alifu Alifu", adminLevel: "island" },
            MV008007: { name: "Maalhos-Alifu Alifu", adminLevel: "island" },
            MV008038: { name: "Maayafushi-Alifu Alifu", adminLevel: "island" },
            MV008039: { name: "Madivaru-Alifu Alifu", adminLevel: "island" },
            MV008040: { name: "Madivarufinolhu-Alifu Alifu", adminLevel: "island" },
            MV008041: { name: "Madoogali-Alifu Alifu", adminLevel: "island" },
            MV008042: { name: "Mathivereefinolhu-Alifu Alifu", adminLevel: "island" },
            MV008004: { name: "Mathiveri-Alifu Alifu", adminLevel: "island" },
            MV008010: { name: "Alikoirah-Alifu Alifu", adminLevel: "island" },
            MV008043: { name: "Mushimasmigili-Alifu Alifu", adminLevel: "island" },
            MV008002: { name: "Rasdhoo-Alifu Alifu", adminLevel: "island" },
            MV008001: { name: "Thoddoo-Alifu Alifu", adminLevel: "island" },
            MV008003: { name: "Ukulhas-Alifu Alifu", adminLevel: "island" },
            MV008044: { name: "Velidhoo-Alifu Alifu", adminLevel: "island" },
            MV008045: { name: "Velifinolhu-Alifu Alifu", adminLevel: "island" },
            MV008046: { name: "Veligan'du-Alifu Alifu", adminLevel: "island" },
            MV008009: { name: "Vihamaafaru-Alifu Alifu", adminLevel: "island" },
        }
    },
    // Kaafu Atoll (MV009)
    MV009: {
        name: "Kaafu",
        adminLevel: "atoll",
        children: {
            MV009016: { name: "Baros-Kaafu", adminLevel: "island" },
            MV009017: { name: "Biyaadhoo-Kaafu", adminLevel: "island" },
            MV009019: { name: "Bodubis-Kaafu", adminLevel: "island" },
            MV009020: { name: "Bodufinolhu-Kaafu", adminLevel: "island" },
            MV009021: { name: "Boduhithi-Kaafu", adminLevel: "island" },
            MV009022: { name: "Boduhuraa-Kaafu", adminLevel: "island" },
            MV009023: { name: "Bolifushi-Kaafu", adminLevel: "island" },
            MV009024: { name: "Bulhifushi-Kaafu", adminLevel: "island" },
            MV009003: { name: "Dhiffushi-Kaafu", adminLevel: "island" },
            MV009025: { name: "Dhigufinolhu-Kaafu", adminLevel: "island" },
            MV009026: { name: "Dhonfushi-Kaafu", adminLevel: "island" },
            MV009027: { name: "Dhoonidhoo-Kaafu", adminLevel: "island" },
            MV009028: { name: "Ehmafushi-Kaafu", adminLevel: "island" },
            MV009031: { name: "Eriadhoo-Kaafu", adminLevel: "island" },
            MV009032: { name: "Erruhhuraa-Kaafu", adminLevel: "island" },
            MV009012: { name: "Aarah-Kaafu", adminLevel: "island" },
            MV009033: { name: "Fariiruhuraa-Kaafu", adminLevel: "island" },
            MV009035: { name: "Faritharihuraa-Kaafu", adminLevel: "island" },
            MV009036: { name: "Farivelihuraa-Kaafu", adminLevel: "island" },
            MV009037: { name: "Farukolhufushi-Kaafu", adminLevel: "island" },
            MV009038: { name: "Feydhoofinolhu-Kaafu", adminLevel: "island" },
            MV009039: { name: "Fihaalhohi-Kaafu", adminLevel: "island" },
            MV009040: { name: "Funadhoo-Kaafu", adminLevel: "island" },
            MV009041: { name: "Funfinolhu-Kaafu", adminLevel: "island" },
            MV009042: { name: "Furanafushi-Kaafu", adminLevel: "island" },
            MV009002: { name: "Gaafaru-Kaafu", adminLevel: "island" },
            MV009044: { name: "Gasfinolhu-Kaafu", adminLevel: "island" },
            MV009045: { name: "Giraavaru-Kaafu", adminLevel: "island" },
            MV009046: { name: "Girifushi-Kaafu", adminLevel: "island" },
            MV009007: { name: "Gulhi-Kaafu", adminLevel: "island" },
            MV009047: { name: "Gulhigaathuhuraa-Kaafu", adminLevel: "island" },
            MV009009: { name: "Guraidhoo-Kaafu", adminLevel: "island" },
            MV009048: { name: "Hastheem-Kaafu", adminLevel: "island" },
            MV009049: { name: "Hathaafinolhu-Kaafu", adminLevel: "island" },
            MV009006: { name: "Hinmafushi-Kaafu", adminLevel: "island" },
            MV009052: { name: "Hulhule-Kaafu", adminLevel: "island" },
            MV009005: { name: "Huraa-Kaafu", adminLevel: "island" },
            MV009053: { name: "Ihuru-Kaafu", adminLevel: "island" },
            MV009054: { name: "Ithaafinolhu-Kaafu", adminLevel: "island" },
            MV009055: { name: "Ithaafushi-Kaafu", adminLevel: "island" },
            MV009001: { name: "Kaashidhoo-Kaafu", adminLevel: "island" },
            MV009051: { name: "Hen'badhoo-Kaafu", adminLevel: "island" },
            MV009056: { name: "Kagi-Kaafu", adminLevel: "island" },
            MV009010: { name: "Aanugan'dufinolhu-Kaafu", adminLevel: "island" },
            MV009011: { name: "Aanugan'duhuraa-Kaafu", adminLevel: "island" },
            MV009018: { name: "Boduban'dos-Kaafu", adminLevel: "island" },
            MV009029: { name: "En'boodhoo-Kaafu", adminLevel: "island" },
            MV009030: { name: "En'boodhoofinolhu-Kaafu", adminLevel: "island" },
            MV009057: { name: "Kalhuhuraa-Kaafu", adminLevel: "island" },
            MV009050: { name: "Helen'geli-Kaafu", adminLevel: "island" },
            MV009059: { name: "Kan'doomaafushi-Kaafu", adminLevel: "island" },
            MV009060: { name: "Kan'duoiygiri-Kaafu", adminLevel: "island" },
            MV009061: { name: "Kanifinolhu-Kaafu", adminLevel: "island" },
            MV009062: { name: "Kanuoiyhuraa-Kaafu", adminLevel: "island" },
            MV009063: { name: "Kassanfushi-Kaafu", adminLevel: "island" },
            MV009043: { name: "Gaagan'du-Kaafu", adminLevel: "island" },
            MV009058: { name: "Kan'baashaa-Kaafu", adminLevel: "island" },
            MV009034: { name: "Farikan'duhuraa-Kaafu", adminLevel: "island" },
            MV009064: { name: "Kohdhipparu-Kaafu", adminLevel: "island" },
            MV009065: { name: "Kudaban'dos-Kaafu", adminLevel: "island" },
            MV009066: { name: "Kudafinolhu-Kaafu", adminLevel: "island" },
            MV009067: { name: "Kudagiri-Kaafu", adminLevel: "island" },
            MV009068: { name: "Kudahithi-Kaafu", adminLevel: "island" },
            MV009069: { name: "Kudahuraa-Kaafu", adminLevel: "island" },
            MV009070: { name: "Lankanfinolhu-Kaafu", adminLevel: "island" },
            MV009071: { name: "Lankanfushi-Kaafu", adminLevel: "island" },
            MV009158: { name: "Lhohifushi-Kaafu", adminLevel: "island" },
            MV009159: { name: "Lhosfushi-Kaafu", adminLevel: "island" },
            MV009160: { name: "Maadhoo-Kaafu", adminLevel: "island" },
            MV009008: { name: "Maafushi-Kaafu", adminLevel: "island" },
            MV009161: { name: "Maaranfushi-Kaafu", adminLevel: "island" },
            MV009162: { name: "Madivaru-Kaafu", adminLevel: "island" },
            MV009163: { name: "Mahaanaelhihuraa-Kaafu", adminLevel: "island" },
            MV009164: { name: "Maifalhuhuraa-Kaafu", adminLevel: "island" },
            MV009166: { name: "Makunufushi-Kaafu", adminLevel: "island" },
            MV009167: { name: "Maniyafushi-Kaafu", adminLevel: "island" },
            MV009168: { name: "Medhufinolhu-Kaafu", adminLevel: "island" },
            MV009013: { name: "Akasdhoo-Kaafu", adminLevel: "island" },
            MV009014: { name: "Akirifushi-Kaafu", adminLevel: "island" },
            MV009165: { name: "Makunudhoo-Kaafu", adminLevel: "island" },
            MV009169: { name: "Meerufenfushi-Kaafu", adminLevel: "island" },
            MV009015: { name: "Asdhoo-Kaafu", adminLevel: "island" },
            MV009170: { name: "Nakahchaahuraa-Kaafu", adminLevel: "island" },
            MV009171: { name: "Nakaiychaafushi-Kaafu", adminLevel: "island" },
            MV009172: { name: "Nashvilu-Kaafu", adminLevel: "island" },
            MV009173: { name: "Noofinolhu-Kaafu", adminLevel: "island" },
            MV009174: { name: "Olhigan'dufinolhu-Kaafu", adminLevel: "island" },
            MV009175: { name: "Olhuhali-Kaafu", adminLevel: "island" },
            MV009176: { name: "Olhuveli-Kaafu", adminLevel: "island" },
            MV009177: { name: "Rannaalhi-Kaafu", adminLevel: "island" },
            MV009178: { name: "Rasfari-Kaafu", adminLevel: "island" },
            MV009179: { name: "Than'burudhoo-Kaafu", adminLevel: "island" },
            MV009180: { name: "Thilafushi-Kaafu", adminLevel: "island" },
            MV009181: { name: "Tholhimaraahuraa-Kaafu", adminLevel: "island" },
            MV009182: { name: "Thulhaagiri-Kaafu", adminLevel: "island" },
            MV009004: { name: "Thulusdhoo-Kaafu", adminLevel: "island" },
            MV009183: { name: "Thulusdhoo Irumathee Huraagan'du-Kaafu", adminLevel: "island" },
            MV009184: { name: "Thun'bafushi-Kaafu", adminLevel: "island" },
            MV009185: { name: "Vaadhoo-Kaafu", adminLevel: "island" },
            MV009186: { name: "Vaagali-Kaafu", adminLevel: "island" },
            MV009187: { name: "Vabbinfaru-Kaafu", adminLevel: "island" },
            MV009188: { name: "Vabboahuraa-Kaafu", adminLevel: "island" },
            MV009189: { name: "Vammaafushi-Kaafu", adminLevel: "island" },
            MV009190: { name: "Velassaru-Kaafu", adminLevel: "island" },
            MV009191: { name: "Veligan'duhuraa-Kaafu", adminLevel: "island" },
            MV009192: { name: "Vihamanaafushi-Kaafu", adminLevel: "island" },
            MV009193: { name: "Vilin'gilimathidhahuraa-Kaafu", adminLevel: "island" },
            MV009194: { name: "Villivaru-Kaafu", adminLevel: "island" },
            MV009195: { name: "Ziyaaraiyfushi-Kaafu", adminLevel: "island" },
        }
    },
    // Vaavu Atoll (MV010)
    MV010: {
        name: "Vaavu",
        adminLevel: "atoll",
        children: {
            MV010003: { name: "Felidhoo-Vaavu", adminLevel: "island" },
            MV010001: { name: "Fulidhoo-Vaavu", adminLevel: "island" },
            MV010004: { name: "Keyodhoo-Vaavu", adminLevel: "island" },
            MV010013: { name: "Kuda Anbaraa-Vaavu", adminLevel: "island" },
            MV010014: { name: "Kudamohoraa-Vaavu", adminLevel: "island" },
            MV010015: { name: "Kunaaveshi-Vaavu", adminLevel: "island" },
            MV010005: { name: "Rakeedhoo-Vaavu", adminLevel: "island" },
            MV010002: { name: "Thinadhoo-Vaavu", adminLevel: "island" },
            MV010046: { name: "Thun'duhuraa-Vaavu", adminLevel: "island" },
            MV010006: { name: "Aarah-Vaavu", adminLevel: "island" },
            MV010007: { name: "Alimathaa-Vaavu", adminLevel: "island" },
            MV010008: { name: "Anbaraa-Vaavu", adminLevel: "island" },
            MV010009: { name: "Bodumohoraa-Vaavu", adminLevel: "island" },
            MV010010: { name: "Dhiggiri-Vaavu", adminLevel: "island" },
            MV010011: { name: "Fohtheyobodufushi-Vaavu", adminLevel: "island" },
            MV010012: { name: "Hulhidhoo-Vaavu", adminLevel: "island" },
            MV010047: { name: "Vashugiri-Vaavu", adminLevel: "island" },
            MV010048: { name: "Vattaru-Vaavu", adminLevel: "island" },
        }
    },
    // Faafu Atoll (MV011)
    MV011: {
        name: "Faafu",
        adminLevel: "atoll",
        children: {
            MV011002: { name: "Bileiydhoo-Faafu", adminLevel: "island" },
            MV011007: { name: "Dhiguvarufinolhu-Faafu", adminLevel: "island" },
            MV011006: { name: "Adhangau-Faafu", adminLevel: "island" },
            MV011004: { name: "Dharan'boodhoo-Faafu", adminLevel: "island" },
            MV011008: { name: "En'bulufushi-Faafu", adminLevel: "island" },
            MV011009: { name: "Faanumaahuraa-Faafu", adminLevel: "island" },
            MV011001: { name: "Feeali-Faafu", adminLevel: "island" },
            MV011010: { name: "Filitheyo-Faafu", adminLevel: "island" },
            MV011011: { name: "Himithi-Faafu", adminLevel: "island" },
            MV011012: { name: "Jinnathugau-Faafu", adminLevel: "island" },
            MV011013: { name: "Kan'dumoonufushi-Faafu", adminLevel: "island" },
            MV011028: { name: "Maafushi-Faafu", adminLevel: "island" },
            MV011029: { name: "Madivaruhuraa-Faafu", adminLevel: "island" },
            MV011003: { name: "Magoodhoo-Faafu", adminLevel: "island" },
            MV011030: { name: "Magoodhoobodufinolhu-Faafu", adminLevel: "island" },
            MV011031: { name: "Makunueri-Faafu", adminLevel: "island" },
            MV011032: { name: "Minimasgali-Faafu", adminLevel: "island" },
            MV011005: { name: "Nilandhoo-Faafu", adminLevel: "island" },
            MV011033: { name: "Vilin'gilivarufinolhu-Faafu", adminLevel: "island" },
        }
    },
    // Dhaalu Atoll (MV012)
    MV012: {
        name: "Dhaalu",
        adminLevel: "atoll",
        children: {
            MV012011: { name: "Boarikifinolhu-Dhaalu", adminLevel: "island" },
            MV012012: { name: "Bodufushi-Dhaalu", adminLevel: "island" },
            MV012013: { name: "Bulhalafushi-Dhaalu", adminLevel: "island" },
            MV012014: { name: "Dhebaidhoo-Dhaalu", adminLevel: "island" },
            MV012002: { name: "Ban'didhoo-Dhaalu", adminLevel: "island" },
            MV012015: { name: "Dhoores-Dhaalu", adminLevel: "island" },
            MV012016: { name: "En'boodhoofushi-Dhaalu", adminLevel: "island" },
            MV012017: { name: "Faandhoo-Dhaalu", adminLevel: "island" },
            MV012018: { name: "Fenfushi-Dhaalu", adminLevel: "island" },
            MV012005: { name: "Gemendhoo-Dhaalu", adminLevel: "island" },
            MV012019: { name: "Hinaidhoo-Dhaalu", adminLevel: "island" },
            MV012020: { name: "Hiriyafushi-Dhaalu", adminLevel: "island" },
            MV012021: { name: "Hudhufusheefinolhu-Dhaalu", adminLevel: "island" },
            MV012004: { name: "Hulhudheli-Dhaalu", adminLevel: "island" },
            MV012022: { name: "Hulhuvahi-Dhaalu", adminLevel: "island" },
            MV012023: { name: "Issari-Dhaalu", adminLevel: "island" },
            MV012024: { name: "Kan'dinmaa-Dhaalu", adminLevel: "island" },
            MV012025: { name: "Kanneiyfaru-Dhaalu", adminLevel: "island" },
            MV012026: { name: "Kedhigan'du-Dhaalu", adminLevel: "island" },
            MV012027: { name: "Kiraidhoo-Dhaalu", adminLevel: "island" },
            MV012008: { name: "Kudahuvadhoo-Dhaalu", adminLevel: "island" },
            MV012028: { name: "Kudathilabolhufushi-Dhaalu", adminLevel: "island" },
            MV012052: { name: "Lhohi-Dhaalu", adminLevel: "island" },
            MV012053: { name: "Maadheli-Dhaalu", adminLevel: "island" },
            MV012007: { name: "Maaen'boodhoo-Dhaalu", adminLevel: "island" },
            MV012054: { name: "Maafushi-Dhaalu", adminLevel: "island" },
            MV012055: { name: "Maagau-Dhaalu", adminLevel: "island" },
            MV012056: { name: "Maalefaru-Dhaalu", adminLevel: "island" },
            MV012009: { name: "Aluvifushi-Dhaalu", adminLevel: "island" },
            MV012001: { name: "Meedhoo-Dhaalu", adminLevel: "island" },
            MV012057: { name: "Meedhuffushi-Dhaalu", adminLevel: "island" },
            MV012058: { name: "Minimasgali-Dhaalu", adminLevel: "island" },
            MV012010: { name: "Ayyakaloahuraa-Dhaalu", adminLevel: "island" },
            MV012059: { name: "Olhufushi-Dhaalu", adminLevel: "island" },
            MV012060: { name: "Olhuveli-Dhaalu", adminLevel: "island" },
            MV012003: { name: "Rin'budhoo-Dhaalu", adminLevel: "island" },
            MV012061: { name: "Sarakafushi-Dhaalu", adminLevel: "island" },
            MV012062: { name: "Than'balhaidhoo-Dhaalu", adminLevel: "island" },
            MV012063: { name: "Thilabolhufushi-Dhaalu", adminLevel: "island" },
            MV012064: { name: "Thinhuraa-Dhaalu", adminLevel: "island" },
            MV012065: { name: "Uhdhoo-Dhaalu", adminLevel: "island" },
            MV012006: { name: "Vaanee-Dhaalu", adminLevel: "island" },
            MV012066: { name: "Valla-Dhaalu", adminLevel: "island" },
            MV012067: { name: "Vallalhohi-Dhaalu", adminLevel: "island" },
            MV012068: { name: "Velavaru-Dhaalu", adminLevel: "island" },
            MV012069: { name: "Vommuli-Dhaalu", adminLevel: "island" },
        }
    },
    // Meemu Atoll (MV013)
    MV013: {
        name: "Meemu",
        adminLevel: "atoll",
        children: {
            MV013010: { name: "Boahuraa-Meemu", adminLevel: "island" },
            MV013012: { name: "Dhekunuboduveli-Meemu", adminLevel: "island" },
            MV013008: { name: "Dhiggaru-Meemu", adminLevel: "island" },
            MV013014: { name: "Erruhhuraa-Meemu", adminLevel: "island" },
            MV013016: { name: "Fenfuraaveli-Meemu", adminLevel: "island" },
            MV013017: { name: "Gaakurali-Meemu", adminLevel: "island" },
            MV013018: { name: "Gasveli-Meemu", adminLevel: "island" },
            MV013019: { name: "Gongalihuraa-Meemu", adminLevel: "island" },
            MV013020: { name: "Hakuraahuraa-Meemu", adminLevel: "island" },
            MV013021: { name: "Hudhuveli-Meemu", adminLevel: "island" },
            MV013022: { name: "Hurasveli-Meemu", adminLevel: "island" },
            MV013023: { name: "Kakaahuraa-Meemu", adminLevel: "island" },
            MV013024: { name: "Kekuraalhuveli-Meemu", adminLevel: "island" },
            MV013007: { name: "Kolhufushi-Meemu", adminLevel: "island" },
            MV013025: { name: "Kudausfushi-Meemu", adminLevel: "island" },
            MV013011: { name: "Bodukan'duhuraa-Meemu", adminLevel: "island" },
            MV013013: { name: "Dhihthun'di-Meemu", adminLevel: "island" },
            MV013015: { name: "Etherefasgan'du-Meemu", adminLevel: "island" },
            MV013026: { name: "Kuradhigan'du-Meemu", adminLevel: "island" },
            MV013056: { name: "Maahuraa-Meemu", adminLevel: "island" },
            MV013057: { name: "Maalhaveli-Meemu", adminLevel: "island" },
            MV013058: { name: "Maausfushi-Meemu", adminLevel: "island" },
            MV013002: { name: "Madifushi-Meemu", adminLevel: "island" },
            MV013009: { name: "Maduvvari-Meemu", adminLevel: "island" },
            MV013059: { name: "Medhufushi-Meemu", adminLevel: "island" },
            MV013004: { name: "Mulah-Meemu", adminLevel: "island" },
            MV013005: { name: "Muli-Meemu", adminLevel: "island" },
            MV013006: { name: "Naalaafushi-Meemu", adminLevel: "island" },
            MV013060: { name: "Raaban'dhihuraa-Meemu", adminLevel: "island" },
            MV013001: { name: "Raiymandhoo-Meemu", adminLevel: "island" },
            MV013061: { name: "Seedheehuraa-Meemu", adminLevel: "island" },
            MV013062: { name: "Seedheehuraaveligan'du-Meemu", adminLevel: "island" },
            MV013063: { name: "Thuvaru-Meemu", adminLevel: "island" },
            MV013064: { name: "Thuvaru Uthuruhuraa-Meemu", adminLevel: "island" },
            MV013065: { name: "Uthuruboduveli-Meemu", adminLevel: "island" },
            MV013066: { name: "Uthurugaseveli-Meemu", adminLevel: "island" },
            MV013067: { name: "Vannanerufasgan'du-Meemu", adminLevel: "island" },
            MV013003: { name: "Veyvah-Meemu", adminLevel: "island" },
        }
    },
    // Thaa Atoll (MV014)
    MV014: {
        name: "Thaa",
        adminLevel: "atoll",
        children: {
            MV014014: { name: "Bodufinolhu-Thaa", adminLevel: "island" },
            MV014023: { name: "Fondhoo-Thaa", adminLevel: "island" },
            MV014015: { name: "Bodurehaa-Thaa", adminLevel: "island" },
            MV014040: { name: "Kani-Thaa", adminLevel: "island" },
            MV014001: { name: "Buruni-Thaa", adminLevel: "island" },
            MV014048: { name: "Kuredhifushi-Thaa", adminLevel: "island" },
            MV014016: { name: "Dhiffushi-Thaa", adminLevel: "island" },
            MV014004: { name: "Dhiyamigili-Thaa", adminLevel: "island" },
            MV014017: { name: "Dhonanfushi-Thaa", adminLevel: "island" },
            MV014021: { name: "Fenfushi-Thaa", adminLevel: "island" },
            MV014022: { name: "Fenmeerufushi-Thaa", adminLevel: "island" },
            MV014024: { name: "Fonidhaani-Thaa", adminLevel: "island" },
            MV014025: { name: "Funaddu-Thaa", adminLevel: "island" },
            MV014026: { name: "Fushi-Thaa", adminLevel: "island" },
            MV014009: { name: "Gaadhiffushi-Thaa", adminLevel: "island" },
            MV014027: { name: "Gaalee-Thaa", adminLevel: "island" },
            MV014028: { name: "Gaathurehaa-Thaa", adminLevel: "island" },
            MV014005: { name: "Guraidhoo-Thaa", adminLevel: "island" },
            MV014029: { name: "Hathifushi-Thaa", adminLevel: "island" },
            MV014008: { name: "Hirilandhoo-Thaa", adminLevel: "island" },
            MV014031: { name: "Hiriyanfushi-Thaa", adminLevel: "island" },
            MV014033: { name: "Hulhiyanfushi-Thaa", adminLevel: "island" },
            MV014034: { name: "Kaaddoo-Thaa", adminLevel: "island" },
            MV014035: { name: "Kafidhoo-Thaa", adminLevel: "island" },
            MV014036: { name: "Kakolhas-Thaa", adminLevel: "island" },
            MV014037: { name: "Kalhudheyfushi-Thaa", adminLevel: "island" },
            MV014038: { name: "Kalhufahalafushi-Thaa", adminLevel: "island" },
            MV014041: { name: "Kanimeedhoo-Thaa", adminLevel: "island" },
            MV014042: { name: "Kolafushi-Thaa", adminLevel: "island" },
            MV014043: { name: "Kolhufushi-Thaa", adminLevel: "island" },
            MV014044: { name: "Kudadhoo-Thaa", adminLevel: "island" },
            MV014045: { name: "Kudakaaddoo-Thaa", adminLevel: "island" },
            MV014062: { name: "Lhavaddoo-Thaa", adminLevel: "island" },
            MV014063: { name: "Maagulhi-Thaa", adminLevel: "island" },
            MV014064: { name: "Maalefushi-Thaa", adminLevel: "island" },
            MV014003: { name: "Madifushi-Thaa", adminLevel: "island" },
            MV014065: { name: "Mathidhoo-Thaa", adminLevel: "island" },
            MV014066: { name: "Medhafushi-Thaa", adminLevel: "island" },
            MV014067: { name: "Olhudhiyafushi-Thaa", adminLevel: "island" },
            MV014068: { name: "Olhufushi-Thaa", adminLevel: "island" },
            MV014069: { name: "Olhufushifinolhu-Thaa", adminLevel: "island" },
            MV014070: { name: "Olhugiri-Thaa", adminLevel: "island" },
            MV014071: { name: "Rihaamaafushi-Thaa", adminLevel: "island" },
            MV014072: { name: "Ruhthibirah-Thaa", adminLevel: "island" },
            MV014010: { name: "Thimarafushi-Thaa", adminLevel: "island" },
            MV014073: { name: "Ufuriyaa-Thaa", adminLevel: "island" },
            MV014074: { name: "Usfushi-Thaa", adminLevel: "island" },
            MV014006: { name: "Kan'doodhoo-Thaa", adminLevel: "island" },
            MV014012: { name: "Kin'bidhoo-Thaa", adminLevel: "island" },
            MV014018: { name: "Dhururehaa-Thaa", adminLevel: "island" },
            MV014019: { name: "Ekuruffushi-Thaa", adminLevel: "island" },
            MV014020: { name: "Elaa-Thaa", adminLevel: "island" },
            MV014030: { name: "Hikan'dhilhohi-Thaa", adminLevel: "island" },
            MV014032: { name: "Hon'delifushi-Thaa", adminLevel: "island" },
            MV014039: { name: "Kan'dufushi-Thaa", adminLevel: "island" },
            MV014046: { name: "Kudakin'bidhoo-Thaa", adminLevel: "island" },
            MV014047: { name: "Kuran'dhuvaru-Thaa", adminLevel: "island" },
            MV014013: { name: "Omadhoo-Thaa", adminLevel: "island" },
            MV014075: { name: "Vanbadhi-Thaa", adminLevel: "island" },
            MV014007: { name: "Vandhoo-Thaa", adminLevel: "island" },
            MV014011: { name: "Veymandoo-Thaa", adminLevel: "island" },
            MV014002: { name: "Vilufushi-Thaa", adminLevel: "island" },
        }
    },
    // Laamu Atoll (MV015)
    MV015: {
        name: "Laamu",
        adminLevel: "atoll",
        children: {
            MV015017: { name: "Bodufenrahaa-Laamu", adminLevel: "island" },
            MV015018: { name: "Bodufinolhu-Laamu", adminLevel: "island" },
            MV015020: { name: "Boduhuraa-Laamu", adminLevel: "island" },
            MV015022: { name: "Bodumaabulhali-Laamu", adminLevel: "island" },
            MV015023: { name: "Bodumahigulhi-Laamu", adminLevel: "island" },
            MV015024: { name: "Bodumungnafushi-Laamu", adminLevel: "island" },
            MV015026: { name: "Burrahaa-Laamu", adminLevel: "island" },
            MV015028: { name: "Dhonberahaa-Laamu", adminLevel: "island" },
            MV015029: { name: "Enberahaa-Laamu", adminLevel: "island" },
            MV015030: { name: "Fares-Laamu", adminLevel: "island" },
            MV015031: { name: "Fenboahuraa-Laamu", adminLevel: "island" },
            MV015032: { name: "Fenboarahaa-Laamu", adminLevel: "island" },
            MV015008: { name: "Fonadhoo-Laamu", adminLevel: "island" },
            MV015033: { name: "Fonagaadhoo-Laamu", adminLevel: "island" },
            MV015034: { name: "Fushi-Laamu", adminLevel: "island" },
            MV015009: { name: "Gaadhoo-Laamu", adminLevel: "island" },
            MV015013: { name: "Gan-Laamu", adminLevel: "island" },
            MV015036: { name: "Guraidhoo-Laamu", adminLevel: "island" },
            MV015037: { name: "Haiythoshi-Laamu", adminLevel: "island" },
            MV015038: { name: "Hanhushi-Laamu", adminLevel: "island" },
            MV015039: { name: "Hendha-Laamu", adminLevel: "island" },
            MV015011: { name: "Hithadhoo-Laamu", adminLevel: "island" },
            MV015041: { name: "Holhurahaa-Laamu", adminLevel: "island" },
            MV015042: { name: "Hulhimendhoo-Laamu", adminLevel: "island" },
            MV015043: { name: "Hulhisdhoo-Laamu", adminLevel: "island" },
            MV015044: { name: "Hulhiyandhoo-Laamu", adminLevel: "island" },
            MV015001: { name: "Isdhoo-Laamu", adminLevel: "island" },
            MV015045: { name: "Kadhdhoo-Laamu", adminLevel: "island" },
            MV015005: { name: "Kalaidhoo-Laamu", adminLevel: "island" },
            MV015046: { name: "Kalhaidhoo-Laamu", adminLevel: "island" },
            MV015047: { name: "Kalhurahaa-Laamu", adminLevel: "island" },
            MV015048: { name: "Kandaru-Laamu", adminLevel: "island" },
            MV015049: { name: "Kanuhuraa-Laamu", adminLevel: "island" },
            MV015050: { name: "Kashidhoo-Laamu", adminLevel: "island" },
            MV015002: { name: "Dhan'bidhoo-Laamu", adminLevel: "island" },
            MV015027: { name: "Dhekunuvinagan'du-Laamu", adminLevel: "island" },
            MV015035: { name: "Gasgan'dufinolhu-Laamu", adminLevel: "island" },
            MV015051: { name: "Kokurahaa-Laamu", adminLevel: "island" },
            MV015040: { name: "Hikan'dhirahaa-Laamu", adminLevel: "island" },
            MV015052: { name: "Kudafenrehaa-Laamu", adminLevel: "island" },
            MV015053: { name: "Kudafushi-Laamu", adminLevel: "island" },
            MV015054: { name: "Kudamaabulhali-Laamu", adminLevel: "island" },
            MV015055: { name: "Kudamahigulhi-Laamu", adminLevel: "island" },
            MV015056: { name: "Kudamungnafushi-Laamu", adminLevel: "island" },
            MV015057: { name: "Kudarah-Laamu", adminLevel: "island" },
            MV015058: { name: "Kudaveshi-Laamu", adminLevel: "island" },
            MV015012: { name: "Kunahandhoo-Laamu", adminLevel: "island" },
            MV015059: { name: "Kuredhirehaa-Laamu", adminLevel: "island" },
            MV015003: { name: "Maabaidhoo-Laamu", adminLevel: "island" },
            MV015076: { name: "Maafushi-Laamu", adminLevel: "island" },
            MV015077: { name: "Maakalhuveli-Laamu", adminLevel: "island" },
            MV015010: { name: "Maamendhoo-Laamu", adminLevel: "island" },
            MV015078: { name: "Maandhoo-Laamu", adminLevel: "island" },
            MV015007: { name: "Maavah-Laamu", adminLevel: "island" },
            MV015079: { name: "Maaveshi-Laamu", adminLevel: "island" },
            MV015014: { name: "Aarahaa-Laamu", adminLevel: "island" },
            MV015080: { name: "Mahakanfushi-Laamu", adminLevel: "island" },
            MV015081: { name: "Medhuvinagan'du-Laamu", adminLevel: "island" },
            MV015082: { name: "Mendhoo-Laamu", adminLevel: "island" },
            MV015015: { name: "Athahendhu-Laamu", adminLevel: "island" },
            MV015016: { name: "Baresdhoo-Laamu", adminLevel: "island" },
            MV015004: { name: "Mundoo-Laamu", adminLevel: "island" },
            MV015025: { name: "Bokaiyfushi-Laamu", adminLevel: "island" },
            MV015083: { name: "Olhutholhu-Laamu", adminLevel: "island" },
            MV015084: { name: "Olhuveli-Laamu", adminLevel: "island" },
            MV015085: { name: "Rahaa-Laamu", adminLevel: "island" },
            MV015086: { name: "Thathunrahaa-Laamu", adminLevel: "island" },
            MV015087: { name: "Thun'buri-Laamu", adminLevel: "island" },
            MV015088: { name: "Uthuruvinagan'du-Laamu", adminLevel: "island" },
            MV015089: { name: "Uvadhevifushi-Laamu", adminLevel: "island" },
            MV015090: { name: "Vadinolhu-Laamu", adminLevel: "island" },
            MV015091: { name: "Veligan'dufinolhu-Laamu", adminLevel: "island" },
        }
    },
    // Gaafu Alifu Atoll (MV016)
    MV016: {
        name: "Gaafu Alifu",
        adminLevel: "atoll",
        children: {
            MV016015: { name: "Beyrumauddoo-Gaafu Alifu", adminLevel: "island" },
            MV016016: { name: "Bihurehaa-Gaafu Alifu", adminLevel: "island" },
            MV016017: { name: "Boadduvaa-Gaafu Alifu", adminLevel: "island" },
            MV016018: { name: "Bodehuttaa-Gaafu Alifu", adminLevel: "island" },
            MV016020: { name: "Boduhuttaa-Gaafu Alifu", adminLevel: "island" },
            MV016005: { name: "Dhaandhoo-Gaafu Alifu", adminLevel: "island" },
            MV016021: { name: "Dhevvaamaagalaa-Gaafu Alifu", adminLevel: "island" },
            MV016006: { name: "Dhevvadhoo-Gaafu Alifu", adminLevel: "island" },
            MV016022: { name: "Dhevvalaabadhoo-Gaafu Alifu", adminLevel: "island" },
            MV016023: { name: "Dhigudhoo-Gaafu Alifu", adminLevel: "island" },
            MV016024: { name: "Dhigurah-Gaafu Alifu", adminLevel: "island" },
            MV016008: { name: "Dhiyadhoo-Gaafu Alifu", adminLevel: "island" },
            MV016025: { name: "Falhumaafushi-Gaafu Alifu", adminLevel: "island" },
            MV016027: { name: "Faruhulhudhoo-Gaafu Alifu", adminLevel: "island" },
            MV016028: { name: "Fenfuttaa-Gaafu Alifu", adminLevel: "island" },
            MV016029: { name: "Fenrehaa-Gaafu Alifu", adminLevel: "island" },
            MV016019: { name: "Bodubon'deyyaa-Gaafu Alifu", adminLevel: "island" },
            MV016030: { name: "Fulan'gi-Gaafu Alifu", adminLevel: "island" },
            MV016031: { name: "Funadhoo-Gaafu Alifu", adminLevel: "island" },
            MV016032: { name: "Funadhooviligillaa-Gaafu Alifu", adminLevel: "island" },
            MV016033: { name: "Funamauddaa-Gaafu Alifu", adminLevel: "island" },
            MV016034: { name: "Galamedhuvaa-Gaafu Alifu", adminLevel: "island" },
            MV016009: { name: "Gemanafushi-Gaafu Alifu", adminLevel: "island" },
            MV016035: { name: "Han'dahaa-Gaafu Alifu", adminLevel: "island" },
            MV016036: { name: "Hinaamaagalaa-Gaafu Alifu", adminLevel: "island" },
            MV016037: { name: "Hirihuttaa-Gaafu Alifu", adminLevel: "island" },
            MV016038: { name: "Hithaadhoo-Gaafu Alifu", adminLevel: "island" },
            MV016039: { name: "Hithaadhoogalaa-Gaafu Alifu", adminLevel: "island" },
            MV016040: { name: "Hulhimendhoo-Gaafu Alifu", adminLevel: "island" },
            MV016041: { name: "Hurendhoo-Gaafu Alifu", adminLevel: "island" },
            MV016042: { name: "Idhimaa-Gaafu Alifu", adminLevel: "island" },
            MV016043: { name: "Innarehaa-Gaafu Alifu", adminLevel: "island" },
            MV016044: { name: "Kalhehuttaa-Gaafu Alifu", adminLevel: "island" },
            MV016045: { name: "Kaludirehaa-Gaafu Alifu", adminLevel: "island" },
            MV016010: { name: "Kan'duhulhudhoo-Gaafu Alifu", adminLevel: "island" },
            MV016046: { name: "Kan'duvilin'gili-Gaafu Alifu", adminLevel: "island" },
            MV016047: { name: "Kendheraa-Gaafu Alifu", adminLevel: "island" },
            MV016048: { name: "Keredhdhoo-Gaafu Alifu", adminLevel: "island" },
            MV016049: { name: "Kisserahaa-Gaafu Alifu", adminLevel: "island" },
            MV016050: { name: "Kodagehuttaa-Gaafu Alifu", adminLevel: "island" },
            MV016051: { name: "Kodahuttaa-Gaafu Alifu", adminLevel: "island" },
            MV016052: { name: "Kodeyvilin'gili-Gaafu Alifu", adminLevel: "island" },
            MV016001: { name: "Kolamaafushi-Gaafu Alifu", adminLevel: "island" },
            MV016007: { name: "Kon'dey-Gaafu Alifu", adminLevel: "island" },
            MV016053: { name: "Kon'deymatheelaabadhoo-Gaafu Alifu", adminLevel: "island" },
            MV016054: { name: "Kooddoo-Gaafu Alifu", adminLevel: "island" },
            MV016055: { name: "Kudalafari-Gaafu Alifu", adminLevel: "island" },
            MV016082: { name: "Lhossaa-Gaafu Alifu", adminLevel: "island" },
            MV016084: { name: "Maadhigavara-Gaafu Alifu", adminLevel: "island" },
            MV016085: { name: "Maafehelaa-Gaafu Alifu", adminLevel: "island" },
            MV016086: { name: "Maagihuttaa-Gaafu Alifu", adminLevel: "island" },
            MV016087: { name: "Maakanaarataa-Gaafu Alifu", adminLevel: "island" },
            MV016003: { name: "Maamendhoo-Gaafu Alifu", adminLevel: "island" },
            MV016088: { name: "Maamutaa-Gaafu Alifu", adminLevel: "island" },
            MV016089: { name: "Maarandhoo-Gaafu Alifu", adminLevel: "island" },
            MV016090: { name: "Maarehaa-Gaafu Alifu", adminLevel: "island" },
            MV016091: { name: "Mahahdhoo-Gaafu Alifu", adminLevel: "island" },
            MV016092: { name: "Mahthidhoo-Gaafu Alifu", adminLevel: "island" },
            MV016093: { name: "Mahthurehaa-Gaafu Alifu", adminLevel: "island" },
            MV016094: { name: "Matu-Gaafu Alifu", adminLevel: "island" },
            MV016095: { name: "Medharehaa-Gaafu Alifu", adminLevel: "island" },
            MV016096: { name: "Medhehuttaa-Gaafu Alifu", adminLevel: "island" },
            MV016097: { name: "Medhuburiyaa-Gaafu Alifu", adminLevel: "island" },
            MV016098: { name: "Melaimaa-Gaafu Alifu", adminLevel: "island" },
            MV016099: { name: "Meradhoo-Gaafu Alifu", adminLevel: "island" },
            MV016011: { name: "Araigahthaa-Gaafu Alifu", adminLevel: "island" },
            MV016012: { name: "Baaberehutta-Gaafu Alifu", adminLevel: "island" },
            MV016013: { name: "Baavanadhoo-Gaafu Alifu", adminLevel: "island" },
            MV016014: { name: "Bakehthaa-Gaafu Alifu", adminLevel: "island" },
            MV016100: { name: "Minimessaa-Gaafu Alifu", adminLevel: "island" },
            MV016101: { name: "Munandhuvaa-Gaafu Alifu", adminLevel: "island" },
            MV016004: { name: "Nilandhoo-Gaafu Alifu", adminLevel: "island" },
            MV016102: { name: "Raaverrehaa-Gaafu Alifu", adminLevel: "island" },
            MV016103: { name: "Viligalaa-Gaafu Alifu", adminLevel: "island" },
            MV016002: { name: "Vilin'gili-Gaafu Alifu", adminLevel: "island" },
            MV016104: { name: "Vodamulaa-Gaafu Alifu", adminLevel: "island" },
        }
    },
    // Gaafu Dhaalu Atoll (MV017)
    MV017: {
        name: "Gaafu Dhaalu",
        adminLevel: "atoll",
        children: {
            MV017020: { name: "Beeraahuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017021: { name: "Bodehuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017024: { name: "Bodeinsa-Gaafu Dhaalu", adminLevel: "island" },
            MV017025: { name: "Boderehaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017026: { name: "Bolimathaidhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017027: { name: "Bolimathaidhua-Gaafu Dhaalu", adminLevel: "island" },
            MV017028: { name: "Dhatekarunahuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017029: { name: "Dhatemulaidhua-Gaafu Dhaalu", adminLevel: "island" },
            MV017030: { name: "Dhathaidhuaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017031: { name: "Dhekaamba-Gaafu Dhaalu", adminLevel: "island" },
            MV017032: { name: "Dherukerehaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017033: { name: "Dhigelaabadhuvaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017034: { name: "Dhigurehaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017035: { name: "Dhinmanaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017037: { name: "Dhiyanigillaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017009: { name: "Dhoonirehaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017040: { name: "Ehivakaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017041: { name: "Ekelondaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017042: { name: "Ekurukerataa-Gaafu Dhaalu", adminLevel: "island" },
            MV017043: { name: "Faahuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017044: { name: "Faanehuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017045: { name: "Faathiyehuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017046: { name: "Faredhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017047: { name: "Farehalehuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017048: { name: "Farehulhehdhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017008: { name: "Faresmaathodaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017049: { name: "Farukolhuhuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017050: { name: "Fatefandhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017051: { name: "Femunaidhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017052: { name: "Fenevenehuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017054: { name: "Filaarataa-Gaafu Dhaalu", adminLevel: "island" },
            MV017007: { name: "Fiyoaree-Gaafu Dhaalu", adminLevel: "island" },
            MV017055: { name: "Fonehigillaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017053: { name: "Fereythavilin'gili-Gaafu Dhaalu", adminLevel: "island" },
            MV017056: { name: "Gahevelegalaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017057: { name: "Gan-Gaafu Dhaalu", adminLevel: "island" },
            MV017058: { name: "Gazeeraa-Gaafu Dhaalu", adminLevel: "island" },
            MV017059: { name: "Golhaallaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017060: { name: "Goshi-Gaafu Dhaalu", adminLevel: "island" },
            MV017061: { name: "Haadhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017063: { name: "Hadahahuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017064: { name: "Hakandoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017066: { name: "Han'dhebalanerehaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017068: { name: "Haveyyerataa-Gaafu Dhaalu", adminLevel: "island" },
            MV017069: { name: "Havoddaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017070: { name: "Havodigalaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017072: { name: "Hiyanigilihuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017002: { name: "Hoan'dehdhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017073: { name: "Hoothodeyaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017074: { name: "Hulhehdhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017075: { name: "Hulhuvaarulaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017076: { name: "Hunigoderehaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017077: { name: "Huttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017078: { name: "Isdhuhuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017013: { name: "Kaadehdhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017079: { name: "Kaafarataa-Gaafu Dhaalu", adminLevel: "island" },
            MV017080: { name: "Kaalhehuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017081: { name: "Kaashidhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017082: { name: "Kadelerataa-Gaafu Dhaalu", adminLevel: "island" },
            MV017083: { name: "Kadevaarehaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017084: { name: "Kadhefala-Gaafu Dhaalu", adminLevel: "island" },
            MV017085: { name: "Kafena-Gaafu Dhaalu", adminLevel: "island" },
            MV017086: { name: "Kalhehamalaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017087: { name: "Kalhehigillaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017088: { name: "Kalhehuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017089: { name: "Kalherehaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017091: { name: "Kan'dahalagalaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017090: { name: "Kanandhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017092: { name: "Kandahdhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017093: { name: "Kannigilla-Gaafu Dhaalu", adminLevel: "island" },
            MV017094: { name: "Kautihulhadhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017095: { name: "Kavvahuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017096: { name: "Kelaihuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017097: { name: "Keraminthaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017098: { name: "Keredhirehaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017099: { name: "Keyhuvadhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017101: { name: "Kodedhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017102: { name: "Kodegalaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017103: { name: "Kodehutigalaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017104: { name: "Kodurataa-Gaafu Dhaalu", adminLevel: "island" },
            MV017105: { name: "Konottaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017106: { name: "Kudhebeeraahuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017108: { name: "Kudhehaadhuaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017109: { name: "Kudhehulhehdhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017110: { name: "Kudhemaadhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017112: { name: "Kudherataa-Gaafu Dhaalu", adminLevel: "island" },
            MV017113: { name: "Kurehdhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017114: { name: "Kureikeymaahuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017115: { name: "Laihaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017131: { name: "Lifadhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017132: { name: "Lonudhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017133: { name: "Lonudhoohuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017134: { name: "Maadhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017135: { name: "Maagalaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017136: { name: "Maagoderehaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017137: { name: "Maahutigalaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017138: { name: "Maakirigalla-Gaafu Dhaalu", adminLevel: "island" },
            MV017139: { name: "Maallaarehaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017140: { name: "Maanaidhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017141: { name: "Maarehaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017143: { name: "Maavaaruloo-Gaafu Dhaalu", adminLevel: "island" },
            MV017144: { name: "Maavehdhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017001: { name: "Madaveli-Gaafu Dhaalu", adminLevel: "island" },
            MV017145: { name: "Maguhdhuvaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017146: { name: "Mathaidhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017147: { name: "Mathihuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017148: { name: "Meehinethiyenehuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017149: { name: "Menthandhuvaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017150: { name: "Meragihuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017151: { name: "Meyragillaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017017: { name: "Athihuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017018: { name: "Badefodiyaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017152: { name: "Mudhimaahutta-Gaafu Dhaalu", adminLevel: "island" },
            MV017003: { name: "Nadellaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017153: { name: "Neimaahutta-Gaafu Dhaalu", adminLevel: "island" },
            MV017154: { name: "Odagallaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017155: { name: "Oinigillaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017156: { name: "Olhimuntaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017157: { name: "Olhurataa-Gaafu Dhaalu", adminLevel: "island" },
            MV017158: { name: "Raabodaafeheerataa-Gaafu Dhaalu", adminLevel: "island" },
            MV017159: { name: "Raaverinkolhihuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017160: { name: "Rahadhuvaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017005: { name: "Rathafandhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017161: { name: "Rodaadhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017162: { name: "Rodhavarrehaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017011: { name: "Thelehuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017010: { name: "Thinadhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017163: { name: "Thinehuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017019: { name: "Baulhegalla-Gaafu Dhaalu", adminLevel: "island" },
            MV017164: { name: "Uhehootirataa-Gaafu Dhaalu", adminLevel: "island" },
            MV017165: { name: "Uherehaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017166: { name: "Uhurehaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017167: { name: "Ulegalaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017006: { name: "Vaadhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017004: { name: "Gadhdhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017111: { name: "Kudhemathaidhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017168: { name: "Vaareyadhuvaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017016: { name: "Anhenerehaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017036: { name: "Dhiyanegili-Gaafu Dhaalu", adminLevel: "island" },
            MV017062: { name: "Haadhuaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017065: { name: "Han'daidhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017071: { name: "Hevaahulhudhoo-Gaafu Dhaalu", adminLevel: "island" },
            MV017100: { name: "Kodaanahuttaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017107: { name: "Kudhe-ehivakaa", adminLevel: "island" },
            MV017169: { name: "Vatavarrehaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017170: { name: "Veraaviligillaa-Gaafu Dhaalu", adminLevel: "island" },
            MV017171: { name: "Viligillaa-Gaafu Dhaalu", adminLevel: "island" },
        }
    },
    // Gnaviyani Atoll (MV018)
    MV018: {
        name: "Gnaviyani",
        adminLevel: "atoll",
        children: {
            MV018001: { name: "Fuvahmulah-Gnaviyani", adminLevel: "island" },
        }
    },
    // Seenu Atoll (MV019)
    MV019: {
        name: "Seenu",
        adminLevel: "atoll",
        children: {
            MV019026: { name: "Bedhey Aurah-Seenu", adminLevel: "island" },
            MV019027: { name: "Boduhajaraa-Seenu", adminLevel: "island" },
            MV019028: { name: "Bolihera-Seenu", adminLevel: "island" },
            MV019030: { name: "Dhigiheraa-Seenu", adminLevel: "island" },
            MV019031: { name: "Dhonhera-Seenu", adminLevel: "island" },
            MV019004: { name: "Feydhoo-Seenu", adminLevel: "island" },
            MV019033: { name: "Gan-Seenu", adminLevel: "island" },
            MV019034: { name: "Geskalhuheraa-Seenu", adminLevel: "island" },
            MV019035: { name: "Gomahera-Seenu", adminLevel: "island" },
            MV019036: { name: "Hankede-Seenu", adminLevel: "island" },
            MV019037: { name: "Hasanbeaarah-Seenu", adminLevel: "island" },
            MV019038: { name: "Herethere-Seenu", adminLevel: "island" },
            MV019039: { name: "Hikahera-Seenu", adminLevel: "island" },
            MV019002: { name: "Hithadhoo-Seenu", adminLevel: "island" },
            MV019006: { name: "Hulhudhoo-Seenu", adminLevel: "island" },
            MV019040: { name: "Ismehelaahera-Seenu", adminLevel: "island" },
            MV019042: { name: "Kaohera-Seenu", adminLevel: "island" },
            MV019043: { name: "Kedevaahera-Seenu", adminLevel: "island" },
            MV019044: { name: "Kudamaahera-Seenu", adminLevel: "island" },
            MV019045: { name: "Kudhehera-Seenu", adminLevel: "island" },
            MV019056: { name: "Maahera-Seenu", adminLevel: "island" },
            MV019029: { name: "Dheeron'di-Seenu", adminLevel: "island" },
            MV019032: { name: "Fathikedeheragan'du-Seenu", adminLevel: "island" },
            MV019041: { name: "Kan'diheragan'du-Seenu", adminLevel: "island" },
            MV019003: { name: "Maradhoo-Seenu", adminLevel: "island" },
            MV019005: { name: "Maradhoofeydhoo-Seenu", adminLevel: "island" },
            MV019057: { name: "Mulikede-Seenu", adminLevel: "island" },
            MV019058: { name: "Savaaheli-Seenu", adminLevel: "island" },
            MV019001: { name: "Meedhoo-Seenu", adminLevel: "island" },
            MV019025: { name: "Vilin'gili-Seenu", adminLevel: "island" },
        }
    },
    // Alifu Dhaalu Atoll (MV020)
    MV020: {
        name: "Alifu Dhaalu",
        adminLevel: "atoll",
        children: {
            MV020015: { name: "Bodufinolhu-Alifu Dhaalu", adminLevel: "island" },
            MV020016: { name: "Bodukaashihuraa-Alifu Dhaalu", adminLevel: "island" },
            MV020017: { name: "Bulhalhohi-Alifu Dhaalu", adminLevel: "island" },
            MV020006: { name: "Dhan'gethi-Alifu Dhaalu", adminLevel: "island" },
            MV020009: { name: "Dhidhdhoo-Alifu Dhaalu", adminLevel: "island" },
            MV020018: { name: "Dhiffushi-Alifu Dhaalu", adminLevel: "island" },
            MV020019: { name: "Dhiggiri-Alifu Dhaalu", adminLevel: "island" },
            MV020007: { name: "Dhigurah-Alifu Dhaalu", adminLevel: "island" },
            MV020020: { name: "Dhihdhoofinolhu-Alifu Dhaalu", adminLevel: "island" },
            MV020021: { name: "En'boodhoo-Alifu Dhaalu", adminLevel: "island" },
            MV020008: { name: "Fenfushi-Alifu Dhaalu", adminLevel: "island" },
            MV020022: { name: "Fushidhigga-Alifu Dhaalu", adminLevel: "island" },
            MV020001: { name: "Hangnaameedhoo-Alifu Dhaalu", adminLevel: "island" },
            MV020023: { name: "Heenfaru-Alifu Dhaalu", adminLevel: "island" },
            MV020024: { name: "Hiyafushi-Alifu Dhaalu", adminLevel: "island" },
            MV020025: { name: "Hukurudhoo-Alifu Dhaalu", adminLevel: "island" },
            MV020026: { name: "Hurasdhoo-Alifu Dhaalu", adminLevel: "island" },
            MV020027: { name: "Huruelhi-Alifu Dhaalu", adminLevel: "island" },
            MV020028: { name: "Huvahendhoo-Alifu Dhaalu", adminLevel: "island" },
            MV020029: { name: "Innafushi-Alifu Dhaalu", adminLevel: "island" },
            MV020030: { name: "Kalhahan'dhihuraa-Alifu Dhaalu", adminLevel: "island" },
            MV020031: { name: "Kudadhoo-Alifu Dhaalu", adminLevel: "island" },
            MV020032: { name: "Kudarah-Alifu Dhaalu", adminLevel: "island" },
            MV020003: { name: "Kun'burudhoo-Alifu Dhaalu", adminLevel: "island" },
            MV020067: { name: "Lonuboi-Alifu Dhaalu", adminLevel: "island" },
            MV020068: { name: "Maafushivaru-Alifu Dhaalu", adminLevel: "island" },
            MV020010: { name: "Maamigili-Alifu Dhaalu", adminLevel: "island" },
            MV020069: { name: "Mahchafushi-Alifu Dhaalu", adminLevel: "island" },
            MV020004: { name: "Mahibadhoo-Alifu Dhaalu", adminLevel: "island" },
            MV020005: { name: "Mandhoo-Alifu Dhaalu", adminLevel: "island" },
            MV020012: { name: "Ariyadhoo-Alifu Dhaalu", adminLevel: "island" },
            MV020013: { name: "Athulivarufinolhu-Alifu Dhaalu", adminLevel: "island" },
            MV020014: { name: "Athurugau-Alifu Dhaalu", adminLevel: "island" },
            MV020070: { name: "Mirihi-Alifu Dhaalu", adminLevel: "island" },
            MV020071: { name: "Moofushi-Alifu Dhaalu", adminLevel: "island" },
            MV020072: { name: "Nalaguraidhoo-Alifu Dhaalu", adminLevel: "island" },
            MV020002: { name: "Omadhoo-Alifu Dhaalu", adminLevel: "island" },
            MV020073: { name: "Ranfinolhu-Alifu Dhaalu", adminLevel: "island" },
            MV020074: { name: "Rangaleefinolhu-Alifu Dhaalu", adminLevel: "island" },
            MV020075: { name: "Rangali-Alifu Dhaalu", adminLevel: "island" },
            MV020076: { name: "Theluveligaa-Alifu Dhaalu", adminLevel: "island" },
            MV020077: { name: "Tholhifushi-Alifu Dhaalu", adminLevel: "island" },
            MV020078: { name: "Thun'dufushi-Alifu Dhaalu", adminLevel: "island" },
            MV020079: { name: "Vakarufalhi-Alifu Dhaalu", adminLevel: "island" },
            MV020011: { name: "Angaagau-Alifu Dhaalu", adminLevel: "island" },
            MV020080: { name: "Vilamendhoo-Alifu Dhaalu", adminLevel: "island" },
            MV020081: { name: "Vilin'gilivaru-Alifu Dhaalu", adminLevel: "island" },
        }
    },
    // Male Atoll (MV021)
    MV021: {
        name: "Male",
        adminLevel: "atoll",
        children: {
            MV021003: { name: "Male-Hulhumaale", adminLevel: "island" },
            MV021001: { name: "Male-Male", adminLevel: "island" },
            MV021002: { name: "Male-Vilin gili", adminLevel: "island" },
        }
    }
}

export const maldivesSeaAdministrativeLevel: AdministrativeLevels = {
    MLSAR01: {
        name: "Addu Atoll",
        adminLevel: "sea",
    },
    MLSAR02: {
        name: "Malé Atoll",
        adminLevel: "sea",
    },
    MLSAR03: {
        name: "Fuvahmulah",
        adminLevel: "sea",
    },
    MLSAR05: {
        name: "South Huvadhu Atoll",
        adminLevel: "sea",
    },
    MLSAR06: {
        name: "North Huvadhu Atoll",
        adminLevel: "sea",
    },
    MLSAR07: {
        name: "Hadhdhunmathi",
        adminLevel: "sea",
    },
    MLSAR08: {
        name: "Kolhumadulu",
        adminLevel: "sea",
    },
    MLSAR09: {
        name: "North Nilandhe Atoll",
        adminLevel: "sea",
    },
    MLSAR10: {
        name: "South Nilandhe Atoll",
        adminLevel: "sea",
    },
    MLSAR11: {
        name: "South Ari Atoll",
        adminLevel: "sea",
    },
    MLSAR12: {
        name: "North Ari Atoll",
        adminLevel: "sea",
    },
    MLSAR13: {
        name: "North Maalhosmadulu",
        adminLevel: "sea",
    },
    MLSAR14: {
        name: "Faadhippolhu",
        adminLevel: "sea",
    },
    MLSAR15: {
        name: "North Miladhunmadulu",
        adminLevel: "sea",
    },
    MLSAR16: {
        name: "South Miladhunmadulu",
        adminLevel: "sea",
    },
    MLSAR17: {
        name: "South Thiladhunmathi",
        adminLevel: "sea",
    },
    MLSAR18: {
        name: "North Thiladhunmathi",
        adminLevel: "sea",
    },
    /* // Gnaviyani Atoll (MV018)
    MV018: {
        name: "Gnaviyani",
        adminLevel: "atoll",
        children: {
            MV018001: { name: "Fuvahmulah", adminLevel: "island" }
        }
    },
    // Seenu Atoll (MV019)
    MV019: {
        name: "Seenu",
        adminLevel: "atoll",
    },
    // Alifu Dhaalu Atoll (MV020)
    MV020: {
        name: "Alifu Dhaalu",
        adminLevel: "atoll",
    },
    // Male Atoll (MV021)
    MV021: {
        name: "Male",
        adminLevel: "atoll",
    } */
}

type MVAdminType = {
    code: string
    name: string
    adminLevel: string
    adminLevelNumber: number
}

export const mvAdmin: MVAdminType[] = [
    { code: "MV001", name: "Haa Alifu", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV001001", name: "Thuraakunu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001002", name: "Uligamu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001003", name: "Berinmadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001005", name: "Mulhadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001006", name: "Huvarafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001007", name: "Ihavandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001008", name: "Kelaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001009", name: "Vashafaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001010", name: "Dhihdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001011", name: "Filladhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001012", name: "Maarandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001013", name: "Thakandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001014", name: "Utheemu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001015", name: "Muraidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001016", name: "Baarah", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001018", name: "Alidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001019", name: "Alidhuffarufinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001024", name: "Gaamathikulhudhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001032", name: "Maafinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001035", name: "Manafaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001037", name: "Medhafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001039", name: "Naridhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV001042", name: "Van'gaaru", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV002", name: "Haa Dhaalu", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV002003", name: "Hanimaadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002004", name: "Finey", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002005", name: "Naivaadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002006", name: "Hirimaradhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002007", name: "Nolhivaranfaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002008", name: "Nellaidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002009", name: "Nolhivaramu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002010", name: "Kurin'bee", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002012", name: "Kulhudhuffushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002013", name: "Kumundhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002014", name: "Neykurendhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002015", name: "Vaikaradhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002017", name: "Makunudhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002018", name: "Dhipparufushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002021", name: "Hon'daafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002026", name: "Kudafarufasgandu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002027", name: "Kudamuraidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002031", name: "Muiri", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002032", name: "Naagoashi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV002034", name: "Theefaridhoo", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV003", name: "Shaviyani", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV003001", name: "Kan'ditheemu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003002", name: "Noomaraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003003", name: "Goidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003004", name: "Feydhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003005", name: "Feevah", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003006", name: "Bileiyfahi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003007", name: "Foakaidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003008", name: "Narudhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003010", name: "Maroshi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003011", name: "Lhaimagu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003012", name: "Firun'baidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003013", name: "Komandoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003014", name: "Maaun'goodhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003015", name: "Funadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003016", name: "Milandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003022", name: "Dholhiyadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003025", name: "Ekasdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003026", name: "Eriadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003028", name: "Fushifaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003029", name: "Gaakoshibi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003032", name: "Hurasfaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003033", name: "Kakaaeriyadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003034", name: "Kan'baalifaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003035", name: "Keekimini", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003038", name: "Kudalhaimendhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003047", name: "Madidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003048", name: "Madikuredhdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003050", name: "Medhukun'burudhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003053", name: "Naainfarufinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV003059", name: "Van'garu", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV004", name: "Noonu", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV004001", name: "Hen'badhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004002", name: "Ken'dhikulhudhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004003", name: "Maalhendhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004004", name: "Kudafari", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004005", name: "Landhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004006", name: "Maafaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004007", name: "Lhohi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004008", name: "Miladhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004009", name: "Magoodhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004010", name: "Manadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004011", name: "Holhudhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004012", name: "Fohdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004013", name: "Velidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004014", name: "Ban'daidhihdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004017", name: "Bomasdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004022", name: "Dhigurah", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004024", name: "Ehdhuffarumairah", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004025", name: "Ekulhivaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004027", name: "Felivaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004029", name: "Fushivelavaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004031", name: "Huivani", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004033", name: "Huvan'dhumaavattaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004042", name: "Kudafunafaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004043", name: "Kudafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004044", name: "Kunnamalei", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004061", name: "Loafaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004064", name: "Maakurehdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004066", name: "Maavelavaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004067", name: "Medhafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004068", name: "Medhufaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004069", name: "Minaavaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004071", name: "Orivaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004073", name: "Raafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004074", name: "Raalhulaakolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004075", name: "Randheli", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004076", name: "Than'burudhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004077", name: "Than'burudhuffushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004079", name: "Thoshigan'dukolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV004080", name: "Vavathi", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV005", name: "Lhaviyani", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV005001", name: "Hinnavaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005002", name: "Naifaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005003", name: "Kurendhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005004", name: "Olhuvelifushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005006", name: "Aligau", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005009", name: "Bodufinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005012", name: "Dheruffinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005016", name: "Faadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005020", name: "Felivaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005025", name: "Hudhufushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005026", name: "Huravalhi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005027", name: "Innahuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005029", name: "Kanifushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005030", name: "Kanuhuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005031", name: "Komandoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005032", name: "Kudadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005033", name: "Kurehdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005061", name: "Lhohi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005063", name: "Maabinhuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005065", name: "Madhiriguraidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005070", name: "Medha Adihuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005074", name: "Ookolhufinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005076", name: "Thilamaafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV005080", name: "Veyvah", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV006", name: "Raa", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV006001", name: "Alifushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006002", name: "Vaadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006003", name: "Rasgetheemu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006004", name: "An'golhitheemu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006005", name: "Hulhudhuffaaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006006", name: "Un'goofaaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006008", name: "Maakurathu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006009", name: "Rasmaadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006010", name: "Innamaadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006011", name: "Maduvvari", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006012", name: "In'guraidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006013", name: "Fainu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006014", name: "Meedhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006015", name: "Kinolhas", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006017", name: "Gaaun'doodhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006018", name: "Un'gulu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006019", name: "Dhuvaafaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006020", name: "Aarah", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006024", name: "Bodufarufinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006026", name: "Bodufushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006027", name: "Boduhaiykodi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006028", name: "Dheburidheythereyvaadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006030", name: "Dhigali", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006035", name: "Ehthigili", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006037", name: "Faarufushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006039", name: "Fasmendhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006040", name: "Fenfushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006041", name: "Filaidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006042", name: "Fuggiri", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006043", name: "Furaveri", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006052", name: "Huruvalhi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006053", name: "Ifuru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006055", name: "Kan'doogan'du", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006057", name: "Kottefaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006059", name: "Kudafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006060", name: "Kudakurathu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006066", name: "Kuroshigiri", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006093", name: "Lhohi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006094", name: "Lin'boakandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006095", name: "Lun'dhufushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006096", name: "Maamin'gili", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006097", name: "Maamunagau", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006099", name: "Maanenfushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006103", name: "Meedhupparu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006106", name: "Muravandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006111", name: "Uthurumaafaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV006116", name: "Veyvah", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV007", name: "Baa", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV007001", name: "Kudarikilu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007002", name: "Kamadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007003", name: "Kendhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007004", name: "Kihaadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007005", name: "Dhonfanu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007006", name: "Dharavandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007007", name: "Maalhos", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007008", name: "Eydhafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007009", name: "Thulhaadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007010", name: "Hithaadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007011", name: "Fulhadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007012", name: "Fehendhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007013", name: "Goidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007015", name: "Aidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007021", name: "Bodufinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007022", name: "Boifushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007024", name: "Dhandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007026", name: "Dhigudhefaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007027", name: "Dhigufaruvinagan'du", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007029", name: "Dhunikolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007030", name: "En'boodhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007031", name: "Fares", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007032", name: "Finolhas", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007034", name: "Fonimagoodhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007035", name: "Funadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007041", name: "Hibalhidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007042", name: "Hirundhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007043", name: "Horubadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007045", name: "Huraafaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007046", name: "Innafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007048", name: "Kanufushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007049", name: "Kashidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007051", name: "Kihaadhuffaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007052", name: "Kihavahhuravalhi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007054", name: "Kunfunadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007055", name: "Lan'daagiraavaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007097", name: "Maamaduvvari", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007098", name: "Maarikilu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007102", name: "Mendhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007103", name: "Milaidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007104", name: "Miriandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007105", name: "Mudhdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007106", name: "Muthaafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007110", name: "Thiladhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007111", name: "Ufuligiri", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007112", name: "Un'doodhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007113", name: "Vakkaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV007118", name: "Voavah", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV008", name: "Alifu Alifu", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV008001", name: "Thoddoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008002", name: "Rasdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008003", name: "Ukulhas", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008004", name: "Mathiveri", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008005", name: "Bodufolhudhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008006", name: "Feridhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008007", name: "Maalhos", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008008", name: "Himendhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008011", name: "Bathalaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008013", name: "Ellaidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008014", name: "Etheremadivaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008015", name: "Fesdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008019", name: "Gaathafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008020", name: "Gangehi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008021", name: "Halaveli", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008022", name: "Kan'dholhudhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008023", name: "Kudafolhudhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008024", name: "Kuramathi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008037", name: "Maagau", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008038", name: "Maayafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008041", name: "Madoogali", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008042", name: "Mathivereefinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008043", name: "Mushimasmigili", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008044", name: "Velidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV008046", name: "Veligan'du", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV009", name: "Kaafu", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV009001", name: "Kaashidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009002", name: "Gaafaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009003", name: "Dhiffushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009004", name: "Thulusdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009005", name: "Huraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009006", name: "Hinmafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009007", name: "Gulhi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009008", name: "Maafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009009", name: "Guraidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009010", name: "Aanugan'dufinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009011", name: "Aanugan'duhuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009012", name: "Aarah", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009013", name: "Akasdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009014", name: "Akirifushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009015", name: "Asdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009016", name: "Baros", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009017", name: "Biyaadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009018", name: "Boduban'dos", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009020", name: "Bodufinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009021", name: "Boduhithi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009022", name: "Boduhuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009023", name: "Bolifushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009025", name: "Dhigufinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009026", name: "Dhonfushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009027", name: "Dhoonidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009028", name: "Ehmafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009029", name: "En'boodhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009030", name: "En'boodhoofinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009031", name: "Eriadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009032", name: "Erruhhuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009037", name: "Farukolhufushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009038", name: "Feydhoofinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009039", name: "Fihaalhohi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009041", name: "Funfinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009042", name: "Furanafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009044", name: "Gasfinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009045", name: "Giraavaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009046", name: "Girifushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009047", name: "Gulhigaathuhuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009048", name: "Hastheem", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009049", name: "Hathaafinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009050", name: "Helen'geli", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009051", name: "Hen'badhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009052", name: "Hulhule", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009053", name: "Ihuru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009055", name: "Ithaafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009056", name: "Kagi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009059", name: "Kan'doomaafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009060", name: "Kan'duoiygiri", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009061", name: "Kanifinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009062", name: "Kanuoiyhuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009064", name: "Kohdhipparu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009065", name: "Kudaban'dos", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009066", name: "Kudafinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009069", name: "Kudahuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009070", name: "Lankanfinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009071", name: "Lankanfushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009158", name: "Lhohifushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009160", name: "Maadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009161", name: "Maaranfushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009162", name: "Madivaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009163", name: "Mahaanaelhihuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009165", name: "Makunudhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009166", name: "Makunufushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009168", name: "Medhufinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009169", name: "Meerufenfushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009170", name: "Nakahchaahuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009171", name: "Nakaiychaafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009172", name: "Nashvilu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009173", name: "Noofinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009174", name: "Olhigan'dufinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009175", name: "Olhuhali", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009176", name: "Olhuveli", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009177", name: "Rannaalhi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009181", name: "Tholhimaraahuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009182", name: "Thulhaagiri", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009184", name: "Thun'bafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009185", name: "Vaadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009186", name: "Vaagali", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009187", name: "Vabbinfaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009190", name: "Velassaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009191", name: "Veligan'duhuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009192", name: "Vihamanaafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009193", name: "Vilin'gilimathidhahuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009194", name: "Villivaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV009195", name: "Ziyaaraiyfushi", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV010", name: "Vaavu", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV010001", name: "Fulidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV010002", name: "Thinadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV010003", name: "Felidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV010004", name: "Keyodhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV010005", name: "Rakeedhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV010006", name: "Aarah", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV010007", name: "Alimathaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV010008", name: "Anbaraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV010009", name: "Bodumohoraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV010011", name: "Fohtheyobodufushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV010012", name: "Hulhidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV010015", name: "Kunaaveshi", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV011", name: "Faafu", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV011001", name: "Feeali", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV011002", name: "Bileiydhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV011003", name: "Magoodhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV011004", name: "Dharan'boodhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV011005", name: "Nilandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV011008", name: "En'bulufushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV011010", name: "Filitheyo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV011011", name: "Himithi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV011012", name: "Jinnathugau", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV011028", name: "Maafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV011032", name: "Minimasgali", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV012", name: "Dhaalu", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV012001", name: "Meedhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012002", name: "Ban'didhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012003", name: "Rin'budhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012004", name: "Hulhudheli", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012007", name: "Maaen'boodhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012008", name: "Kudahuvadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012009", name: "Aluvifushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012011", name: "Boarikifinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012015", name: "Dhoores", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012016", name: "En'boodhoofushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012017", name: "Faandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012020", name: "Hiriyafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012024", name: "Kan'dinmaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012026", name: "Kedhigan'du", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012052", name: "Lhohi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012054", name: "Maafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012055", name: "Maagau", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012057", name: "Meedhuffushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012060", name: "Olhuveli", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012065", name: "Uhdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012068", name: "Velavaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV012069", name: "Vommuli", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV013", name: "Meemu", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV013001", name: "Raiymandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013002", name: "Madifushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013003", name: "Veyvah", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013004", name: "Mulah", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013005", name: "Muli", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013006", name: "Naalaafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013007", name: "Kolhufushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013008", name: "Dhiggaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013009", name: "Maduvvari", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013010", name: "Boahuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013012", name: "Dhekunuboduveli", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013016", name: "Fenfuraaveli", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013017", name: "Gaakurali", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013018", name: "Gasveli", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013020", name: "Hakuraahuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013022", name: "Hurasveli", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013024", name: "Kekuraalhuveli", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013025", name: "Kudausfushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013058", name: "Maausfushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013059", name: "Medhufushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013061", name: "Seedheehuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013062", name: "Seedheehuraaveligan'du", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013063", name: "Thuvaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013065", name: "Uthuruboduveli", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV013066", name: "Uthurugaseveli", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV014", name: "Thaa", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV014001", name: "Burunee", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014002", name: "Vilufushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014003", name: "Madifushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014004", name: "Dhiyamigili", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014005", name: "Guraidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014006", name: "Kan'doodhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014007", name: "Vandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014008", name: "Hirilandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014009", name: "Gaadhiffushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014010", name: "Thimarafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014011", name: "Veymandoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014012", name: "Kin'bidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014013", name: "Omadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014018", name: "Dhururehaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014019", name: "Ekuruffushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014020", name: "Elaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014025", name: "Funaddu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014034", name: "Kaaddoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014037", name: "Kalhudheyfushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014041", name: "Kanimeedhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014064", name: "Maalefushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014068", name: "Olhufushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014069", name: "Olhufushifinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014070", name: "Olhugiri", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV014072", name: "Ruhthibirah", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV015", name: "Laamu", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV015001", name: "Isdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015002", name: "Dhan'bidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015003", name: "Maabaidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015004", name: "Mundoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015005", name: "Kalaidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015007", name: "Maavah", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015008", name: "Fonadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015009", name: "Gaadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015010", name: "Maamendhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015011", name: "Hithadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015012", name: "Kunahandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015013", name: "Gan", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015016", name: "Baresdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015018", name: "Bodufinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015019", name: "Bodufinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015021", name: "Boduhuraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015030", name: "Fares", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015036", name: "Guraidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015037", name: "Haiythoshi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015045", name: "Kadhdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015048", name: "Kandaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015050", name: "Kashidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015053", name: "Kudafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015078", name: "Maandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015080", name: "Mahakanfushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015082", name: "Mendhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015084", name: "Olhuveli", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV015090", name: "Vadinolhu", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV016", name: "Gaafu Alifu", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV016001", name: "Kolamaafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016002", name: "Vilin'gili", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016003", name: "Maamendhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016004", name: "Nilandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016005", name: "Dhaandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016006", name: "Dhevvadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016007", name: "Kon'dey", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016009", name: "Gemanafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016010", name: "Kan'duhulhudhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016014", name: "Bakehthaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016022", name: "Dhevvalaabadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016024", name: "Dhigurah", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016025", name: "Falhumaafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016031", name: "Funadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016032", name: "Funadhooviligillaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016033", name: "Funamauddaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016035", name: "Han'dahaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016036", name: "Hinaamaagalaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016037", name: "Hirihuttaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016039", name: "Hithaadhoogalaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016048", name: "Keredhdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016053", name: "Kon'deymatheelaabadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016054", name: "Kooddoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016066", name: "LD1449", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016088", name: "Maamutaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016089", name: "Maarandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016090", name: "Maarehaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016091", name: "Mahahdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016099", name: "Meradhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016102", name: "Raaverrehaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV016104", name: "Vodamulaa", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV017", name: "Gaafu Dhaalu", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV017001", name: "Madaveli", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017002", name: "Hoadehdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017003", name: "Nadellaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017004", name: "Gahdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017005", name: "Rathafandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017006", name: "Vaadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017007", name: "Fiyoari", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017008", name: "Faresmaathodaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017010", name: "Thinadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017013", name: "Kaadehdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017026", name: "Bolimathaidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017034", name: "Dhigurehaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017039", name: "Dhoonirehaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017049", name: "Farukolhuhuttaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017053", name: "Fereythavilin'gili", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017058", name: "Gazeeraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017069", name: "Havoddaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017081", name: "Kaashidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017083", name: "Kadevaarehaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017084", name: "Kadhefala", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017104", name: "Kodurataa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017105", name: "Konottaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017112", name: "Kudherataa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017133", name: "Lonudhoohuttaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017139", name: "Maallaarehaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017143", name: "Maavaaruloo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017144", name: "Maavehdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017145", name: "Maguhdhuvaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017156", name: "Olhimuntaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017160", name: "Rahadhuvaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV017169", name: "Vatavarrehaa", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV018", name: "Gnaviyani", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV018001", name: "Fuvahmulah", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV019", name: "Seenu", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV019001", name: "Meedhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV019002", name: "Hithadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV019003", name: "Maradhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV019004", name: "Feydhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV019005", name: "Maradhoofeydhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV019006", name: "Hulhudhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV019025", name: "Vilin'gili", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV019033", name: "Gan", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV019034", name: "Geskalhuheraa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV019035", name: "Gomahera", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV019036", name: "Hankede", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV019038", name: "Herethere", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV019040", name: "Ismehelaahera", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV019057", name: "Mulikede", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV019058", name: "Savaaheli", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV020", name: "Alifu Dhaalu", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV020001", name: "Hangnaameedhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020002", name: "Omadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020003", name: "Kun'burudhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020004", name: "Mahibadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020005", name: "Mandhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020006", name: "Dhan'gethi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020007", name: "Dhigurah", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020008", name: "Fenfushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020009", name: "Dhihdhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020010", name: "Maamin'gili", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020011", name: "Angaagau", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020012", name: "Ariyadhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020014", name: "Athurugau", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020015", name: "Bodufinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020018", name: "Dhiffushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020020", name: "Dhihdhoofinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020023", name: "Heenfaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020025", name: "Hukurudhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020027", name: "Huruelhi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020028", name: "Huvahendhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020029", name: "Innafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020032", name: "Kudarah", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020067", name: "Lonuboi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020068", name: "Maafushivaru", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020069", name: "Mahchafushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020070", name: "Mirihi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020071", name: "Moofushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020072", name: "Nalaguraidhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020074", name: "Rangaleefinolhu", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020076", name: "Theluveligaa", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020077", name: "Tholhifushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020078", name: "Thun'dufushi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020079", name: "Vakarufalhi", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020080", name: "Vilamendhoo", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV020081", name: "Vilin'gilivaru", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MV021", name: "Male", adminLevel: "atoll", adminLevelNumber: 1 },
    { code: "MV021001", name: "Maale", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV021002", name: "Vilin'gili", adminLevel: "island", adminLevelNumber: 2 },
    { code: "MV021003", name: "Hulhumaale", adminLevel: "island", adminLevelNumber: 2 },

    { code: "MLSAR01", name: "Addu Atoll", adminLevel: "sea", adminLevelNumber: 5 },
    { code: "MLSAR02", name: "Malé Atoll", adminLevel: "sea", adminLevelNumber: 5 },
    { code: "MLSAR03", name: "Fuvahmulah", adminLevel: "sea", adminLevelNumber: 5 },
    { code: "MLSAR05", name: "South Huvadhu Atoll", adminLevel: "sea", adminLevelNumber: 5 },
    { code: "MLSAR06", name: "North Huvadhu Atoll", adminLevel: "sea", adminLevelNumber: 5 },
    { code: "MLSAR07", name: "Hadhdhunmathi", adminLevel: "sea", adminLevelNumber: 5 },
    { code: "MLSAR08", name: "Kolhumadulu", adminLevel: "sea", adminLevelNumber: 5 },
    { code: "MLSAR09", name: "North Nilandhe Atoll", adminLevel: "sea", adminLevelNumber: 5 },
    { code: "MLSAR10", name: "South Nilandhe Atoll", adminLevel: "sea", adminLevelNumber: 5 },
    { code: "MLSAR11", name: "South Ari Atoll", adminLevel: "sea", adminLevelNumber: 5 },
    { code: "MLSAR12", name: "North Ari Atoll", adminLevel: "sea", adminLevelNumber: 5 },
    { code: "MLSAR13", name: "North Maalhosmadulu", adminLevel: "sea", adminLevelNumber: 5 },
    { code: "MLSAR14", name: "Faadhippolhu", adminLevel: "sea", adminLevelNumber: 5 },
    { code: "MLSAR15", name: "North Miladhunmadulu", adminLevel: "sea", adminLevelNumber: 5 },
    { code: "MLSAR16", name: "South Miladhunmadulu", adminLevel: "sea", adminLevelNumber: 5 },
    { code: "MLSAR17", name: "South Thiladhunmathi", adminLevel: "sea", adminLevelNumber: 5 },
    { code: "MLSAR18", name: "North Thiladhunmathi", adminLevel: "sea", adminLevelNumber: 5 }
]

export const warningMap = new Map<string, string>([
    ["HRW", "Heavy rain warning"],
    ["HWN", "High wind warning"],
    ["FLW", "Flood warning"],
    ["LIG", "Severe lightning warning"],
    ["LSW", "Land slide warning"],
    ["MWA", "Marine weather warning"],
    ["TW", "Tsunami warning"],
    ["CUS", "Custom warning"],
    ["GUS", "Gust warning"],
  ])

export const getAdminLevelByCode = (areaCode: string): string =>  {
    for (const provinceKey in maldivesAdministrativeLevel) {
        const province = maldivesAdministrativeLevel[provinceKey];

        // Province-level match
        if (provinceKey === areaCode) {
            return province.adminLevel;
        }

        // Check districts
        for (const districtKey in province.children) {
            const district = province.children[districtKey];

            if (districtKey === areaCode) {
                return district.adminLevel;
            }

            // Check DS divisions
            for (const dsKey in district.children) {
                const ds = district.children[dsKey];

                if (dsKey === areaCode) {
                    return ds.adminLevel;
                }
            }
        }
    }
    return ""; // default if not found
}